(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ── Scroll Reveal ── */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry, idx){
        if(entry.isIntersecting){
          setTimeout(function(){
            entry.target.classList.add('cc4-visible');
          }, idx * 100);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      el.classList.add('cc4-visible');
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yard-sign-booking"] && !Shopify.designMode) return;
  try {
    
/* ══ FIREBASE SETUP ══ */
var FIREBASE_CONFIG={apiKey:"AIzaSyDNXt4CI8hQJOTpfwIumqKcB7oG_fl1KpM",authDomain:"houstone-yard-greetings.firebaseapp.com",databaseURL:"https://houstone-yard-greetings-default-rtdb.firebaseio.com",projectId:"houstone-yard-greetings",storageBucket:"houstone-yard-greetings.firebasestorage.app",messagingSenderId:"161468869724",appId:"1:161468869724:web:424601c2f94ba90c57ca99"};
var _fbDb=null,_fbReady=false,_fbQueue=[];
function loadFirebase(cb){if(_fbReady){cb(_fbDb);return;}_fbQueue.push(cb);if(_fbQueue.length>1)return;function ls(src,next){var s=document.createElement('script');s.src=src;s.onload=next;document.head.appendChild(s);}ls('https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js',function(){ls('https://www.gstatic.com/firebasejs/9.23.0/firebase-database-compat.js',function(){if(!firebase.apps.length)firebase.initializeApp(FIREBASE_CONFIG);_fbDb=firebase.database();_fbReady=true;_fbQueue.forEach(function(fn){fn(_fbDb);});_fbQueue=[];});});}
/* A day is "used" once per ORDER. Shopify Flow writes bookings/<date>/orders/o<orderId>=1
   for the event date AND for every extra day, so the count is always right and a Flow
   retry can never double count. The old numeric bookings/<date>/count still works. */
function _bkInfo(v){
  var out={total:0,extra:0,main:0};
  if(v==null)return out;
  if(typeof v==='number'){out.total=v;out.main=v;return out;}
  if(v.orders&&typeof v.orders==='object'){
    for(var k in v.orders){
      var val=v.orders[k];
      if(!val)continue;
      out.total++;
      if(val==='x'||val==='extra'||(val&&val.x))out.extra++;else out.main++;
    }
  }
  if(!out.total&&typeof v.count==='number'){out.total=v.count;out.main=v.count;}
  return out;
}
function _bkCount(v){return _bkInfo(v).total;}
function fbGetCount(date,cb){loadFirebase(function(db){db.ref('bookings/'+date).once('value').then(function(s){var i=_bkInfo(s.val());cb(i.total,i);}).catch(function(){cb(0,{total:0,extra:0,main:0});});});}
function fbIncrementCount(date,cb){loadFirebase(function(db){db.ref('bookings/'+date+'/count').transaction(function(c){return(c||0)+1;}).then(function(r){cb(null,r.snapshot.val());}).catch(function(e){cb(e,null);});});}
function fbListenCount(date,cb){var ref=null;loadFirebase(function(db){ref=db.ref('bookings/'+date);ref.on('value',function(s){var i=_bkInfo(s.val());cb(i.total,i);});});return{off:function(){if(ref)ref.off();}};}

/* ══ TIME SLOT AVAILABILITY (Firebase: slots/<productId>/<YYYY-MM-DD>/<hour>) ══ */
var TS_HOLD_MS=30*60*1000; /* an un-finished checkout releases its hold after 30 min */
function _tsRef(db,pid,date){return db.ref('slots/'+pid+'/'+date);}
/* Each hour holds one entry per booking:  slots/<pid>/<date>/<hour>/<bookingId> = {s:'hold'|'booked', t:ms}
   so the same hour can be sold up to "capacity" times. Old single-object records still count as 1. */
function _tsEntryLive(e,now){if(!e)return false;if(typeof e!=='object')return true;if(e.s==='booked')return true;if(e.s==='hold')return (now-(e.t||0))<=TS_HOLD_MS;return true;}
function _tsCount(v,skipBid){
  var out={},now=Date.now();
  if(!v||typeof v!=='object')return out;
  for(var h in v){
    var node=v[h],n=0;
    if(!node)continue;
    if(typeof node!=='object'){n=1;}
    else if(node.s){n=_tsEntryLive(node,now)?1:0;}                 /* legacy single record */
    else{for(var k in node){
           if(skipBid&&k===skipBid)continue;                       /* my own hold never blocks me */
           if(_tsEntryLive(node[k],now))n++;
         }}
    if(n>0)out[String(h)]=n;
  }
  return out;
}
function tsNewId(){return 'b'+Date.now().toString(36)+Math.random().toString(36).slice(2,8);}
function tsListen(pid,date,cb,skipBid){var ref=null;loadFirebase(function(db){ref=_tsRef(db,pid,date);ref.on('value',function(s){cb(_tsCount(s.val(),skipBid));});});return{off:function(){if(ref){ref.off();ref=null;}}};}
function tsRelease(pid,date,hours,bid,cb){if(!bid||!date||!hours||!hours.length){cb&&cb();return;}loadFirebase(function(db){var u={};hours.forEach(function(h){u[String(h)+'/'+bid]=null;});_tsRef(db,pid,date).update(u).then(function(){cb&&cb();}).catch(function(){cb&&cb();});});}
function tsWrite(pid,date,hours,bid,status,cb){loadFirebase(function(db){var u={},now=Date.now();hours.forEach(function(h){u[String(h)+'/'+bid]={s:status,t:now};});_tsRef(db,pid,date).update(u).then(function(){cb&&cb(null);}).catch(function(e){cb&&cb(e);});});}
function tsReserve(pid,date,hours,bid,cap,cb){
  cap=Math.max(1,parseInt(cap,10)||1);
  loadFirebase(function(db){
    _tsRef(db,pid,date).transaction(function(cur){
      cur=cur||{};
      var counts=_tsCount(cur,bid),now=Date.now();   /* my own earlier hold is not a conflict */
      for(var i=0;i<hours.length;i++){if((counts[String(hours[i])]||0)>=cap)return;}   /* full -> abort */
      for(var j=0;j<hours.length;j++){
        var k=String(hours[j]),node=cur[k];
        if(!node||typeof node!=='object'||node.s){                                     /* migrate legacy shape */
          var nn={};
          if(node&&typeof node==='object'&&node.s)nn.legacy=node;
          else if(node)nn.legacy={s:'booked',t:0};
          node=nn;
        }
        node[bid]={s:'hold',t:now};
        cur[k]=node;
      }
      return cur;
    },function(err,committed){
      if(err){cb(true);return;}          /* a database hiccup must never block a real order */
      cb(!!committed);
    });
  });
}

(function(){'use strict';

/* ═══════════ PREMIUM CAROUSEL ═══════════ */
function openLightbox(src,alt){
  var ov=document.createElement('div');ov.className='pi-lightbox';
  ov.innerHTML='<button type="button" class="pi-lightbox__close" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button><img src="'+src+'" alt="'+(alt||'').replace(/"/g,'&quot;')+'">';
  document.body.appendChild(ov);document.body.style.overflow='hidden';
  requestAnimationFrame(function(){ov.classList.add('is-open');});
  function close(){ov.classList.remove('is-open');document.body.style.overflow='';document.removeEventListener('keydown',onKey);setTimeout(function(){if(ov.parentNode)ov.parentNode.removeChild(ov);},250);}
  function onKey(e){if(e.key==='Escape')close();}
  ov.addEventListener('click',function(e){if(e.target===ov||e.target.closest('.pi-lightbox__close'))close();});
  document.addEventListener('keydown',onKey);
}
document.querySelectorAll('[data-pi-carousel]').forEach(function(car){
  var track=car.querySelector('.pi-carousel__track');
  var slides=car.querySelectorAll('.pi-carousel__slide');
  if(!track||slides.length===0)return;
  var prev=car.querySelector('.pi-carousel__arrow--prev');
  var next=car.querySelector('.pi-carousel__arrow--next');
  var dots=car.querySelectorAll('.pi-carousel__dot');
  var thumbs=car.querySelectorAll('.pi-carousel__thumb');
  var counter=car.querySelector('.pi-carousel__counter-cur');
  var idx=0,total=slides.length;
  var loop=car.dataset.autoplay==='true';var loopMs=4500;var timer=null;
  function go(i){
    idx=(i+total)%total;
    track.style.transform='translateX(-'+(idx*100)+'%)';
    dots.forEach(function(d,n){d.classList.toggle('is-active',n===idx);});
    thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===idx);if(n===idx)t.scrollIntoView({block:'nearest',inline:'nearest'});});
    if(counter)counter.textContent=idx+1;
    if(prev)prev.disabled=false;if(next)next.disabled=false;
  }
  prev&&prev.addEventListener('click',function(){go(idx-1);rs();});
  next&&next.addEventListener('click',function(){go(idx+1);rs();});
  dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.index);rs();});});
  thumbs.forEach(function(t){t.addEventListener('click',function(){go(+t.dataset.index);rs();});});
  /* swipe */
  var x0=null;
  track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>10){car._pisuppress=true;setTimeout(function(){car._pisuppress=false;},400);}if(Math.abs(dx)>40){dx<0?go(idx+1):go(idx-1);rs();}x0=null;});
  /* keyboard */
  car.setAttribute('tabindex','-1');
  car.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){go(idx-1);}else if(e.key==='ArrowRight'){go(idx+1);}});
  /* click image → open lightbox (larger view) */
  slides.forEach(function(sl){
    if(sl.dataset.mediaType!=='image')return;
    var wrap=sl.querySelector('.pi-carousel__imgwrap');var img=sl.querySelector('.pi-carousel__img');
    if(!wrap||!img)return;wrap.style.cursor='zoom-in';
    wrap.addEventListener('click',function(){if(car._pisuppress)return;openLightbox(img.currentSrc||img.src,img.alt||'');});
  });
  /* zoom on hover (desktop) */
  if(car.dataset.zoom==='true'&&window.matchMedia('(hover:hover)').matches){
    slides.forEach(function(sl){
      var wrap=sl.querySelector('.pi-carousel__imgwrap');
      var img=sl.querySelector('.pi-carousel__img');
      if(!wrap||!img||sl.dataset.mediaType!=='image')return;
      wrap.addEventListener('mouseenter',function(){wrap.classList.add('is-zooming');});
      wrap.addEventListener('mouseleave',function(){wrap.classList.remove('is-zooming');img.style.transformOrigin='center center';});
      wrap.addEventListener('mousemove',function(e){var r=wrap.getBoundingClientRect();var px=((e.clientX-r.left)/r.width)*100;var py=((e.clientY-r.top)/r.height)*100;img.style.transformOrigin=px+'% '+py+'%';});
    });
  }
  /* autoplay */
  function st(){if(loop&&total>1)timer=setInterval(function(){go(idx+1);},loopMs);}
  function rs(){if(timer){clearInterval(timer);st();}}
  st();
  car.addEventListener('mouseenter',function(){if(timer){clearInterval(timer);timer=null;}});
  car.addEventListener('mouseleave',function(){if(loop&&!timer)st();});
  go(0);
});

/* ═══════════ PRODUCT DETAILS VARIANT PICKER ═══════════ */
document.querySelectorAll('[data-pi-pd]').forEach(function(pd){
  var idInput=pd.querySelector('.pi-pd__idinput');
  var priceWrap=pd.querySelector('.pi-pd__price');
  var priceCur=pd.querySelector('.pi-pd__price-cur');
  var dataEl=pd.querySelector('.pi-pd__variants-data');
  var variants=[];try{variants=JSON.parse(dataEl?dataEl.textContent:'[]');}catch(e){variants=[];}
  if(!variants.length)return;

  function money(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}

  /* decode HTML entities (&amp; &quot; &#39; …) so escaped radio values match the JSON values */
  var _dec=document.createElement('textarea');
  function norm(s){
    if(s==null)return '';
    _dec.innerHTML=String(s);
    return (_dec.value||'').replace(/\s+/g,' ').trim().toLowerCase();
  }

  var groups=Array.prototype.slice.call(pd.querySelectorAll('.pi-pd__opts'));

  function selected(){
    return groups.map(function(g){
      var r=g.querySelector('input:checked');
      return r?norm(r.value):null;
    });
  }

  function match(){
    var sel=selected();
    /* exact match on every option */
    for(var i=0;i<variants.length;i++){
      var v=variants[i],ok=true;
      for(var j=0;j<sel.length;j++){
        if(sel[j]===null)continue;
        if(norm((v.options||[])[j])!==sel[j]){ok=false;break;}
      }
      if(ok)return v;
    }
    /* fallback: best partial match (most options matching) */
    var best=null,bestScore=-1;
    for(var k=0;k<variants.length;k++){
      var vv=variants[k],score=0;
      for(var m=0;m<sel.length;m++){
        if(sel[m]!==null&&norm((vv.options||[])[m])===sel[m])score++;
      }
      if(score>bestScore){bestScore=score;best=vv;}
    }
    return bestScore>0?best:null;
  }

  /* ---- instant URL sync: ?variant=ID ---- */
  function syncUrl(id){
    if(!id||!window.history||!window.history.replaceState)return;
    try{
      var url=new URL(window.location.href);
      if(url.searchParams.get('variant')===String(id))return;
      url.searchParams.set('variant',id);
      window.history.replaceState({variantId:id},'',url.toString());
    }catch(e){}
  }

  /* ---- instant price render (no fade / no re-fetch) ---- */
  function renderPrice(v){
    if(priceCur)priceCur.textContent=money(v.price);
    if(!priceWrap)return;
    var was=priceWrap.querySelector('.pi-pd__price-was');
    var save=priceWrap.querySelector('.pi-pd__price-save');
    var hasCompare=v.compare_at_price&&v.compare_at_price>v.price;
    if(hasCompare){
      if(!was){was=document.createElement('s');was.className='pi-pd__price-was';priceWrap.appendChild(was);}
      if(!save){save=document.createElement('span');save.className='pi-pd__price-save';priceWrap.appendChild(save);}
      was.textContent=money(v.compare_at_price);
      save.textContent='Save '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%';
      was.style.display='';save.style.display='';
    }else{
      if(was)was.style.display='none';
      if(save)save.style.display='none';
    }
  }

  /* ---- keep sticky bar / booking root / cart forms on the same variant ---- */
  function syncDataAttrs(v){
    var st=document.querySelector('sticky-add-to-cart');
    if(st){
      st.dataset.currentVariantId=v.id;
      st.setAttribute('data-variant-available',v.available?'true':'false');
      var vt=st.querySelector('.sticky-add-to-cart__variant');
      if(vt&&v.title&&v.title!=='Default Title')vt.textContent=v.title;
    }
    var bk=document.querySelector('.pi-booking');
    if(bk){bk.dataset.variantId=v.id;if(v.title)bk.dataset.variantTitle=v.title;}
    if(idInput)idInput.value=v.id;
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(el){el.value=v.id;});
  }

  var _last=null;
  function update(){
    var v=match();
    if(!v)return;
    if(_last===v.id)return;
    _last=v.id;
    renderPrice(v);
    syncDataAttrs(v);
    syncUrl(v.id);
    document.dispatchEvent(new CustomEvent('variant:changed',{detail:{variant:{id:v.id,title:v.title,price:v.price,available:v.available,compare_at_price:v.compare_at_price}}}));
  }

  /* apply a variant id -> tick its radios */
  function applyVariantId(id){
    var target=null;
    for(var i=0;i<variants.length;i++){if(variants[i].id===id){target=variants[i];break;}}
    if(!target)return false;
    groups.forEach(function(g,idx){
      var want=norm((target.options||[])[idx]);
      if(!want)return;
      g.querySelectorAll('input[type="radio"]').forEach(function(r){r.checked=(norm(r.value)===want);});
    });
    return true;
  }

  /* fire on every possible interaction so the change is immediate */
  ['change','input','click'].forEach(function(evt){
    pd.querySelectorAll('.pi-pd__opts input[type="radio"]').forEach(function(r){
      r.addEventListener(evt,function(){update();},evt==='click');
    });
  });
  groups.forEach(function(g){g.addEventListener('change',function(){update();});});

  /* on load: honour ?variant=ID from the URL, then write the current id back */
  (function init(){
    var uv=parseInt(new URLSearchParams(window.location.search).get('variant'),10);
    if(!isNaN(uv)&&uv>0)applyVariantId(uv);
    update();
  })();

  /* browser back / forward */
  window.addEventListener('popstate',function(){
    var uv=parseInt(new URLSearchParams(window.location.search).get('variant'),10);
    if(isNaN(uv)||uv<=0)return;
    if(applyVariantId(uv)){_last=null;update();}
  });
});

/* ═══════════ HOLIDAYS ═══════════ */
function _nth(n,wd,m,y){var d=new Date(y,m,1),off=(wd-d.getDay()+7)%7;return new Date(y,m,1+off+(n-1)*7);}
function _lastMon(m,y){var l=new Date(y,m+1,0);return new Date(y,m,l.getDate()-(l.getDay()+6)%7);}
function _iso(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
function usaHols(y){return[_iso(new Date(y,0,1)),_iso(_nth(3,1,0,y)),_iso(_nth(3,1,1,y)),_iso(_lastMon(4,y)),_iso(new Date(y,5,19)),_iso(new Date(y,6,4)),_iso(_nth(1,1,8,y)),_iso(_nth(2,1,9,y)),_iso(new Date(y,10,11)),_iso(_nth(4,4,10,y)),_iso(new Date(y,11,25))];}
var _cy=new Date().getFullYear();var ALL_HOLS=usaHols(_cy).concat(usaHols(_cy+1));

function getCurrentVarId(fallback){var p=new URLSearchParams(window.location.search);var uv=parseInt(p.get('variant'),10);if(!isNaN(uv)&&uv>0)return uv;var st=document.querySelector('sticky-add-to-cart');if(st&&st.dataset.currentVariantId){var sv=parseInt(st.dataset.currentVariantId,10);if(!isNaN(sv)&&sv>0)return sv;}var sels=['product-form input[name="id"]','form[action*="/cart/add"] input[name="id"]','.product-form input[name="id"]','[data-product-form] input[name="id"]'];for(var i=0;i<sels.length;i++){var el=document.querySelector(sels[i]);if(el&&el.value){var v=parseInt(el.value,10);if(!isNaN(v)&&v>0)return v;}}return fallback;}

/* checkout confirm */
(function detectCheckout(){var path=window.location.pathname;var ty=path.indexOf('/thank')>-1||document.querySelector('.os-order-number,.thank-you__title,[data-order-id],.order-confirmation')!==null;if(ty){var pd=sessionStorage.getItem('pi_booked_date');if(pd){fbIncrementCount(pd,function(){});sessionStorage.removeItem('pi_booked_date');}return;}})();
(function tsCommitOnThankYou(){
  var path=window.location.pathname;
  var ty=path.indexOf('/thank')>-1||document.querySelector('.os-order-number,.thank-you__title,[data-order-id],.order-confirmation')!==null;
  if(!ty)return;
  var raw=null;try{raw=sessionStorage.getItem('pi_booked_slot');}catch(e){}
  if(!raw)return;
  try{sessionStorage.removeItem('pi_booked_slot');}catch(e){}
  try{var d=JSON.parse(raw);if(d&&d.pid&&d.date&&d.hours&&d.hours.length&&d.bid)tsWrite(d.pid,d.date,d.hours,d.bid,'booked');}catch(e){}
})();
function getSlotInfo(date,limit){return new Promise(function(res){fbGetCount(date,function(c,i){res({total:c,limit:limit,extra:(i&&i.extra)||0,main:(i&&i.main)||c});});});}

/* swatch bg helper */
function swatchBg(name){var l=(name||'').toLowerCase().trim();if(l==='rose gold')return'#b76e79';if(l==='multi color'||l==='multi')return'linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff)';if(l==='gold')return'#d4af37';if(l==='silver')return'#a8a9ad';return l||'#ccc';}
function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}

/* ═══════════ BOOKING FORM INSTANCES ═══════════ */
document.querySelectorAll('[id^="pi-booking-"]').forEach(function(root){
  var sid=root.id.replace('pi-booking-','');
  var today=root.dataset.today;
  var sdHandle=root.dataset.sameDayHandle;
  var hlHandle=root.dataset.holidayHandle;
  var varId=parseInt(root.dataset.variantId,10);
  var DAILY_LIMIT=parseInt((root.dataset.dailyLimit||'6').replace(/[^0-9]/g,''),10)||6;
  var CART_ADD=(root.dataset.cartAddUrl||'/cart/add');
  var CART_URL=(root.dataset.cartUrl||'/cart');
  var CHECKOUT_URL=(root.dataset.checkoutUrl||'/checkout');   /* direct checkout after booking */
  var CLEAR_CART=(root.dataset.clearCart==='true');   /* one booking at a time */
  function $(id){return document.getElementById(id+'-'+sid);}
  function show(el){if(el)el.removeAttribute('hidden');}
  function hide(el){if(el)el.setAttribute('hidden','');}

  /* blocked / holiday dates */
  function expandDates(raw){if(!raw||raw==='none')return[];var out=[];raw.split(',').forEach(function(seg){seg=seg.trim();if(!seg||seg==='none')return;var rm=seg.match(/^(\d{4}-\d{2}-\d{2})\s+to\s+(\d{4}-\d{2}-\d{2})$/i)||seg.match(/^(\d{4}-\d{2}-\d{2}):(\d{4}-\d{2}-\d{2})$/);if(rm){var s=new Date(rm[1]+'T00:00:00'),e=new Date(rm[2]+'T00:00:00'),c=new Date(s),sf=0;while(c<=e&&sf<400){out.push(_iso(c));c.setDate(c.getDate()+1);sf++;}}else if(/^\d{4}-\d{2}-\d{2}$/.test(seg))out.push(seg);});return out;}
  var custDates=expandDates(root.dataset.holidayDates||'');
  var extraBlocked=expandDates(root.dataset.extraBlocked||'');
  var mfBlocked=expandDates(root.dataset.metafieldBlocked||'');
  var mfHolidays=expandDates(root.dataset.metafieldHolidays||'');
  var allHols=ALL_HOLS.concat(custDates).concat(mfHolidays);

  var PRODUCT_TAGS=(root.dataset.productTags||'').split('|').map(function(t){return t.trim().toLowerCase();}).filter(Boolean);

  /* DOM refs */
  var s1=$('pi-s1'),s2=$('pi-s2');
  var stepEls=root.querySelectorAll('.pi-step');
  var dateInp=$('pi-date');
  var slotBar=$('pi-slot-bar'),slotFill=$('pi-slot-fill'),slotText=$('pi-slot-text');
  var noticeRegular=$('pi-notice-regular'),noticeSd=$('pi-notice-sd'),noticeHl=$('pi-notice-hl'),noticeBlocked=$('pi-notice-blocked'),noticeLimit=$('pi-notice-limit'),limitMsg=$('pi-limit-msg'),noticeLoading=$('pi-notice-loading');
  var dynWrap=$('pi-dynamic');
  var pdForm=(root.closest('.pi-col-details')||document).querySelector('.pi-pd__form');
  var nextBtn=$('pi-next'),backBtn=$('pi-back'),bookBtn=$('pi-book'),rrows=$('pi-rrows');
  var noteWrap=$('pi-booking-note'),noteRegular2=$('pi-note-regular'),noteSd2=$('pi-note-sd'),noteHl2=$('pi-note-hl'),totalBox=$('pi-total');
  var noteSlot=$('pi-note-slot'),noteSlotBadge=$('pi-note-slot-badge'),noteSlotText=$('pi-note-slot-text');

  var _dateBlocked=false,_lastSlotInfo=null,_currentVariantPrice=null,_curVarTitle=(root.dataset.variantTitle||''),_curVarId=varId;

  /* ════ DYNAMIC FIELD BUILDER (metafield JSON, filtered by tag & variant) ════ */
  function buildDynamicFields(){
    if(!dynWrap)return;
    var raw='';var sc=$('pi-fields');if(sc)raw=sc.textContent||'';
    var fields=[];try{fields=JSON.parse(raw);}catch(e){fields=[];}
    if(!Array.isArray(fields))fields=[];
    var html='';
    fields.forEach(function(f,i){
      if(!f||typeof f!=='object')return;
      var ftags=f.tags||f.tag||[];if(typeof ftags==='string')ftags=ftags.split(',');ftags=ftags.map(function(t){return(''+t).trim().toLowerCase();}).filter(Boolean);
      if(ftags.length){var anyTag=ftags.some(function(t){return t==='all'||PRODUCT_TAGS.indexOf(t)>-1;});if(!anyTag)return;}
      var fvars=f.variants||f.variant||[];if(typeof fvars==='string')fvars=fvars.split(',');var vAttr=fvars.map(function(x){return(''+x).trim();}).filter(Boolean).join('|');
      var type=(f.type||'text').toLowerCase();
      var label=f.label||f.name||('Field '+(i+1));
      var name=f.name||f.label||('Field '+(i+1));
      var ph=f.placeholder||'';
      var req=f.required===true||f.required==='true';
      var full=(f.full===true)||(f.full!==false&&(type==='textarea'||type==='heading'));
      var fid='pi-dyn-'+i+'-'+sid;
      if(type==='heading'){html+='<div class="pi-fieldhead" data-variants="'+esc(vAttr)+'">'+esc(label)+'</div>';return;}
      var opts=f.options||[];if(typeof opts==='string')opts=opts.split(',');
      var cols=f.colors||f.swatches||[];if(typeof cols==='string')cols=cols.split(',');
      var swF=f.showWhen&&f.showWhen.field?f.showWhen.field:'';
      var swV=f.showWhen&&f.showWhen.value?f.showWhen.value:'';
      html+='<div class="pi-field'+(full?' pi-field--full':'')+'" data-variants="'+esc(vAttr)+'"'+(swF?' data-show-when-field="'+esc(swF)+'" data-show-when-value="'+esc(swV)+'"':'')+'>';
      html+='<label class="pi-lbl'+(req?' pi-lbl--req':'')+'" for="'+fid+'">'+esc(label)+(f.note?' <span class="pi-lbl__note">'+esc(f.note)+'</span>':'')+'</label>';
      if(type==='textarea'){
        html+='<textarea id="'+fid+'" name="properties['+esc(name)+']" class="pi-textarea" rows="3" maxlength="'+(parseInt(f.maxlength,10)||1200)+'"'+(req?' required':'')+' placeholder="'+esc(ph)+'"></textarea>';
      }else if(type==='select'){
        html+='<select id="'+fid+'" name="properties['+esc(name)+']" class="pi-select"'+(req?' required':'')+'><option value="">Select&hellip;</option>';
        opts.forEach(function(o){o=(''+o).trim();if(o)html+='<option>'+esc(o)+'</option>';});
        html+='</select>';
      }else if(type==='radio'){
        html+='<div class="pi-radio-row">';
        opts.forEach(function(o){o=(''+o).trim();if(o)html+='<label class="pi-pill"><input type="radio" name="properties['+esc(name)+']" value="'+esc(o)+'"'+(req?' required':'')+'> '+esc(o)+'</label>';});
        html+='</div>';
      }else if(type==='swatch'){
        html+='<input type="hidden" id="'+fid+'" name="properties['+esc(name)+']"'+(req?' data-required="true"':'')+'>';
        html+='<div class="pi-swatch-row" data-target="'+fid+'" data-required="'+req+'">';
        cols.forEach(function(c){c=(''+c).trim();if(c)html+='<button type="button" class="pi-swatch" data-value="'+esc(c)+'" title="'+esc(c)+'" style="background:'+swatchBg(c)+'"></button>';});
        html+='</div><span class="pi-swatch-selected">None selected</span>';
        if(req)html+='<span class="pi-err-msg" hidden>Please select a color</span>';
      }else{
        var itype=({number:'number',date:'date',tel:'tel',email:'email'})[type]||'text';
        var mlAttr=f.maxlength?' maxlength="'+parseInt(f.maxlength,10)+'"':'';
        html+='<input type="'+itype+'" id="'+fid+'" name="properties['+esc(name)+']" class="pi-input"'+(req?' required':'')+mlAttr+' placeholder="'+esc(ph)+'">';
      }
      html+='</div>';
    });
    html+='<div class="pi-field"><label class="pi-lbl pi-lbl--req" for="pi-ref-'+sid+'">How Did You Find Us?</label><select id="pi-ref-'+sid+'" name="properties[How Did You Find Us]" class="pi-select" required><option value="">Select\u2026</option><option>Google</option><option>Facebook</option><option>Instagram</option><option>Friend / Family Referral</option><option>Nextdoor</option><option>TikTok</option><option>Saw a Sign in a Yard</option><option>Other</option></select></div>';
    dynWrap.innerHTML=html;

    /* ── showWhen — hide/show a field based on another select's current value ── */
    dynWrap.querySelectorAll('[data-show-when-field]').forEach(function(wrap){
      var swField=wrap.getAttribute('data-show-when-field');
      var swVal  =wrap.getAttribute('data-show-when-value');
      var wv     =wrap.getAttribute('data-variants')||'';
      /* find the trigger select that belongs to the SAME variant group — prevents
         Birthday's "Message Format" from being matched against Anniversary's showWhen */
      var trigger=null;
      dynWrap.querySelectorAll('select[name="properties['+swField+']"]').forEach(function(sel){
        var fWrap=sel.closest('.pi-field[data-variants]')||sel.closest('[data-variants]');
        var fv=fWrap?fWrap.getAttribute('data-variants'):'';
        if(fv===wv)trigger=sel;
      });
      if(!trigger)return;
      function applyShowWhen(){
        var matches=(trigger.value===swVal);
        wrap.classList.toggle('pi-field--sw-hidden',!matches);
        if(!matches){wrap.querySelectorAll('input,select,textarea').forEach(function(el){el.value='';});}
      }
      trigger.addEventListener('change',applyShowWhen);
      applyShowWhen();
    });

    /* live character counter — textareas AND text inputs that have a maxlength */
    dynWrap.querySelectorAll('textarea[maxlength],input[maxlength]').forEach(function(ta){
      var max=parseInt(ta.getAttribute('maxlength'),10)||0; if(!max)return;
      var out=document.createElement('span'); out.className='pi-count';
      ta.parentNode.appendChild(out);
      function upd(){
        var n=ta.value.length, left=max-n;
        out.textContent = left<=0 ? ('Limit reached \u2014 '+max+' characters max') : (n+' / '+max);
        out.classList.toggle('is-warn', left>0 && left<=Math.max(20,Math.round(max*0.1)));
        out.classList.toggle('is-full', left<=0);
      }
      ta.addEventListener('input',upd); upd();

/* US phone — instant red on a fake / impossible number, one message line */
    (function(){
      var list=[];
      dynWrap.querySelectorAll('input').forEach(function(i){
        var t=(i.getAttribute('type')||'').toLowerCase();
        var f=i.closest('.pi-field');
        var lab=f?((f.querySelector('.pi-lbl')||{}).textContent||''):'';
        var id=(i.getAttribute('name')||'')+' '+(i.id||'')+' '+lab;
        if(t==='tel'||/phone|mobile|cell/i.test(id))list.push(i);
      });

      list.forEach(function(inp){
        if(inp.dataset.phoneInit)return;
        inp.dataset.phoneInit='1';
        inp.type='tel';
        inp.setAttribute('inputmode','numeric');
        inp.setAttribute('maxlength','14');
        inp.setAttribute('autocomplete','tel-national');
        inp.placeholder='(713) 724-0626';

        var fieldEl=inp.closest('.pi-field')||inp.parentNode;
        fieldEl.querySelectorAll('.pi-phone-err,.pi-phone-hint,.pi-phone-help,.pi-phone-msg')
               .forEach(function(o){o.remove();});

        var msg=document.createElement('span');
        msg.className='pi-phone-msg';
        msg.style.cssText='display:block;font-size:.75rem;margin-top:3px;line-height:1.4';
        inp.parentNode.appendChild(msg);
        function say(text,kind){
          msg.textContent=text;
          msg.style.color = kind==='err' ? '#ff3b30' : kind==='hint' ? '#e08600'
                          : kind==='ok'  ? '#28a745' : 'currentColor';
          msg.style.opacity   = (kind==='help') ? '.55' : '1';
          msg.style.fontWeight= (kind==='err')  ? '600' : '400';
        }

        function digits(v){
          var d=String(v||'').replace(/\D/g,'');
          if(d.length===11&&d.charAt(0)==='1')d=d.slice(1);   /* pasted +1 */
          return d.slice(0,10);
        }
        function fmt(d){
          if(d.length<4)return d;
          if(d.length<7)return '('+d.slice(0,3)+') '+d.slice(3);
          return '('+d.slice(0,3)+') '+d.slice(3,6)+'-'+d.slice(6);
        }

        /* returns an error message the moment it can be proven wrong, else null */
        function why(d){
          var n=d.length;
          if(n>=1&&(d[0]==='0'||d[0]==='1'))
            return 'Area code cannot start with 0 or 1.';
          if(n>=3&&d.slice(1,3)==='11')
            return 'That is a service code (like 411 or 911), not a phone number.';
          if(n>=4&&(d[3]==='0'||d[3]==='1'))
            return 'The digit after the area code cannot be 0 or 1.';
          if(n>=6&&d.slice(3,6)==='555')
            return 'Numbers with a 555 exchange are not real. Please use your actual number.';
          if(n>=7&&/^(\d)\1+$/.test(d))
            return 'Repeated digits are not a real number.';
          if(n>=7&&('0123456789'.indexOf(d)===0||'9876543210'.indexOf(d)===0))
            return 'Sequential digits are not a real number.';
          if(n===10&&(d==='0123456789'||d==='9876543210'))
            return 'Sequential digits are not a real number.';
          return null;
        }

        var lastRaw='';
        function sync(){
          var raw=inp.value;
          var lead=/^\s*(\+?1)[\s\-().]*\d/.test(raw);
          var d=digits(raw);
          var out=fmt(d);
          if(inp.value!==out){
            var atEnd=true;
            try{atEnd=inp.selectionStart===inp.value.length;}catch(e){}
            inp.value=out;
            if(atEnd){try{inp.setSelectionRange(out.length,out.length);}catch(e){}}
          }
          lastRaw=inp.value;

          if(inp.value===''){                          /* empty: "required" handles it */
            inp.dataset.phoneOk='';
            inp.classList.remove('pi-err');
            say('10-digit US number only — no +1, no country code.','help');
            return;
          }

          var problem=why(d);
          if(problem){                                 /* INSTANT red, no waiting for blur */
            inp.dataset.phoneOk='0';
            inp.classList.add('pi-err');
            say(problem,'err');
            return;
          }

          inp.classList.remove('pi-err');
          if(d.length<10){
            inp.dataset.phoneOk='0';
            if(lead)say('Skip the +1 or 1 — just the 10-digit number.','hint');
            else say((10-d.length)+' more digit'+((10-d.length)===1?'':'s')+' to go','help');
            return;
          }
          inp.dataset.phoneOk='1';
          say('Looks good','ok');
        }

        inp.addEventListener('beforeinput',function(e){
          if(e.inputType&&e.inputType.indexOf('delete')===0)return;
          if(e.data==null)return;
          if(/\D/.test(e.data)){e.preventDefault();return;}
          if(digits(inp.value).length>=10&&inp.selectionStart===inp.selectionEnd)e.preventDefault();
        });
        inp.addEventListener('keydown',function(e){
          if(e.key&&e.key.length===1&&!e.ctrlKey&&!e.metaKey&&/\D/.test(e.key))e.preventDefault();
        });
        ['input','keyup','change','cut','paste','blur'].forEach(function(ev){
          inp.addEventListener(ev,function(){setTimeout(sync,0);});
        });

        var watch=null;                                 /* Android keyboards that fire no event */
        inp.addEventListener('focus',function(){
          if(watch)clearInterval(watch);
          watch=setInterval(function(){if(inp.value!==lastRaw)sync();},120);
        });
        inp.addEventListener('blur',function(){if(watch){clearInterval(watch);watch=null;}});

        sync();
      });
    })();
    });
    /* swatch handlers */
    dynWrap.querySelectorAll('.pi-swatch-row').forEach(function(row){
      var hidden=document.getElementById(row.dataset.target);
      var field=row.closest('.pi-field');
      var lblEl=field?field.querySelector('.pi-swatch-selected'):null;
      var errEl=field?field.querySelector('.pi-err-msg'):null;
      row.querySelectorAll('.pi-swatch').forEach(function(sw){sw.addEventListener('click',function(){row.querySelectorAll('.pi-swatch').forEach(function(s){s.classList.remove('pi-swatch--selected');});sw.classList.add('pi-swatch--selected');if(hidden)hidden.value=sw.dataset.value;if(lblEl){lblEl.textContent=sw.dataset.value;lblEl.classList.add('has-value');}row.classList.remove('pi-err');if(errEl)errEl.setAttribute('hidden','');});});
    });
    applyVariantVisibility(_curVarTitle,_curVarId);
  }
  function applyVariantVisibility(title,id){
    if(!dynWrap)return;
    dynWrap.querySelectorAll('[data-variants]').forEach(function(w){
      var raw=w.getAttribute('data-variants')||'';
      if(!raw){w.classList.remove('pi-field--vhidden');w.removeAttribute('hidden');return;}
      var list=raw.split('|').map(function(x){return x.trim();}).filter(Boolean);
      var tl=(title||'').toLowerCase();
      var hit=list.some(function(x){return x.toLowerCase()===tl||x===String(id);});
      w.classList.toggle('pi-field--vhidden',!hit);
      if(hit)w.removeAttribute('hidden');else w.setAttribute('hidden','');
    });
  }
  buildDynamicFields();

  /* ════ VARIANT PRICE/ID SYNC ════ */
  document.addEventListener('variant:changed',function(e){
    var v=(e.detail||{}).variant||{};
    if(v.id)varId=v.id;else varId=getCurrentVarId(varId);
    if(v.price!=null)_currentVariantPrice=v.price;
    if(v.title!=null)_curVarTitle=v.title;_curVarId=varId;
    applyVariantVisibility(_curVarTitle,_curVarId);
    var pe=$('pi-review-price');if(pe&&v.price!=null)pe.textContent='$'+(v.price/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    var ve=$('pi-review-variant');if(ve){var ct=(v.title||'').replace(/\s*[-–]\s*\$[\d,.]+/g,'').trim();if(ct&&ct!=='Default Title'){ve.textContent=' — '+ct;ve.style.display='';}else ve.style.display='none';}
    TS.refreshPrice();
  });

  /* ════════════ TIME SLOT PICKER ════════════ */
  var TS=(function(){
    var stub={enabled:false,onDateChange:function(){},validate:function(){return true;},refreshPrice:function(){},slotFields:function(){return null;},
              getExtra:function(){return null;},rangeText:function(){return '';},
              reserve:function(){return Promise.resolve(true);},remember:function(){},reload:function(){}};
    var wrap=$('pi-ts');
    if(root.dataset.tsEnabled!=='true'||!wrap)return stub;

    /* ── config from data attributes (product metafield -> section fallback) ── */
    /* the Firebase branch this product books against: "all" (store-wide) or the product id */
    var PID=String(root.dataset.tsSlotKey||root.dataset.productId||'all');
    var SCOPE=String(root.dataset.tsScope||'store');
    var MIN=parseInt(root.dataset.tsMin,10);            if(isNaN(MIN)||MIN<1)MIN=4;
    var MAXX=parseInt(root.dataset.tsMaxExtra,10);      if(isNaN(MAXX)||MAXX<0)MAXX=5;
    var DS=parseInt(root.dataset.tsDayStart,10);        if(isNaN(DS)||DS<0||DS>23)DS=7;
    var DE=parseInt(root.dataset.tsDayEnd,10);          if(isNaN(DE)||DE<1||DE>24)DE=22;
    if(DE<=DS)DE=Math.min(24,DS+MIN);
    var LEAD=parseInt(root.dataset.tsLead,10);          if(isNaN(LEAD)||LEAD<0)LEAD=0;
    var FEE_VID=parseInt(String(root.dataset.tsFeeVid||'').replace(/[^0-9]/g,''),10); if(isNaN(FEE_VID))FEE_VID=0;
    var FEE=parseFloat(String(root.dataset.tsFeePrice||'').replace(/[^0-9.]/g,'')); if(isNaN(FEE)||FEE<0)FEE=0;
    var BASE_CENTS=parseInt(root.dataset.variantPrice,10); if(isNaN(BASE_CENTS)||BASE_CENTS<0)BASE_CENTS=0;
    var CAP=parseInt(root.dataset.tsCapacity,10); if(isNaN(CAP)||CAP<1)CAP=1;   /* how many bookings the SAME hour can take */
    /* OFF by default: the slot is only blocked once the ORDER exists (Shopify Flow writes it).
       ON puts a temporary 30-minute hold the moment the item is added to the cart. */
    var HOLD=(root.dataset.tsHold==='true');
    /* gap kept free AFTER every booking - pickup / travel time */
    var BUF=parseInt(root.dataset.tsBuffer,10); if(isNaN(BUF)||BUF<0)BUF=0;
    var FEE_VID2=parseInt(String(root.dataset.tsFeeVid2||'').replace(/[^0-9]/g,''),10); if(isNaN(FEE_VID2))FEE_VID2=0;
    var FEE2=parseFloat(String(root.dataset.tsFeePrice2||'').replace(/[^0-9.]/g,'')); if(isNaN(FEE2)||FEE2<0)FEE2=0;
    /* TIERH = the TOTAL booked hours the tier-1 rate covers. "7" means hours 5,6,7 are tier 1
       and everything past 7 is tier 2. A value <= the minimum is read the old way (extra hours)
       and converted, so 3 and 7 both mean the same thing when the minimum is 4. */
    var TIERH=parseInt(root.dataset.tsTierAfter,10);
    if(isNaN(TIERH)||TIERH<=0)TIERH=999;
    else if(TIERH<=MIN)TIERH=MIN+TIERH;
    /* no tier-2 VARIANT means nothing can actually be charged at the tier-2 rate,
       so never quote it either - the shown price must equal the charged price */
    if(!FEE_VID2)TIERH=999;

    /* ── FLAT PRICE MODE: one variant per duration, added with quantity 1 ──
       Variants are matched by the first number in their title ("Up to 5h" -> 5).
       For a chosen duration we take the first variant whose number is >= it,
       so both "one variant per hour" and "up to X" buckets work. */
    var DURV=(function(){
      var el=$('pi-durfees'); if(!el)return [];
      var raw=[]; try{raw=JSON.parse(el.textContent||'[]');}catch(e){return [];}
      if(!Array.isArray(raw))return [];
      var out=[];
      raw.forEach(function(v){
        if(!v||!v.id)return;
        var m=String(v.t||'').match(/(\d+(?:\.\d+)?)/);
        if(!m)return;
        var h=Math.round(parseFloat(m[1]));
        if(!h||h<=MIN)return;   /* a bucket at or below the minimum carries no extra fee */
        out.push({h:h,id:v.id,price:(parseInt(v.p,10)||0)/100,title:String(v.t||'')});
      });
      out.sort(function(a,b){return a.h-b.h;});
      return out;
    })();
    var FLAT=DURV.length>0;
    var STACK=(root.dataset.tsDurStack==='true');   /* true -> every lower bucket is added on top */

    /* returns the list of fee variants for a duration (1 item, or the whole ladder when stacking) */
    function flatFor(d){
      if(!FLAT)return null;
      var idx=-1;
      for(var i=0;i<DURV.length;i++){if(DURV[i].h>=d){idx=i;break;}}
      if(idx<0)idx=DURV.length-1;
      return STACK?DURV.slice(0,idx+1):[DURV[idx]];
    }
    function flatSum(list){var t=0;(list||[]).forEach(function(v){t+=v.price;});return t;}
    function flatTitles(list){return (list||[]).map(function(v){return v.title;}).join(' + ');}

    /* extra hours -> {h1, h2, fee}  (h1 at the tier-1 rate, h2 at the tier-2 rate) */
    function splitExtra(extra){
      var d=MIN+extra;
      var h1=Math.max(0,Math.min(d,TIERH)-MIN);          /* hours priced at the tier-1 rate */
      var h2=Math.max(0,d-Math.max(MIN,TIERH));          /* hours priced at the tier-2 rate */
      return {h1:h1,h2:h2,fee:h1*FEE+h2*FEE2};
    }

    /* one entry point both modes go through */
    function priceFor(d){
      var extra=d-MIN;
      if(extra<=0)return {extra:0,fee:0,flat:null,h1:0,h2:0};
      if(FLAT){var f=flatFor(d);return {extra:extra,fee:flatSum(f),flat:f,h1:0,h2:0};}
      var sp=splitExtra(extra);
      return {extra:extra,fee:sp.fee,flat:null,h1:sp.h1,h2:sp.h2};
    }
    function basePrice(){ /* dollars — live variant price wins, then the value rendered by Liquid */
      var lp=_currentVariantPrice;
      if(typeof lp==='number'&&lp>=0)return lp/100;
      return BASE_CENTS/100;
    }

    var elEmpty=$('pi-ts-empty'),elLoad=$('pi-ts-loading'),elBody=$('pi-ts-body'),elGrid=$('pi-ts-grid'),
        elNone=$('pi-ts-none'),elDurW=$('pi-ts-dur-wrap'),elDurs=$('pi-ts-durs'),elSum=$('pi-ts-sum'),
        elErr=$('pi-ts-err'),pTime=$('pi-ts-prop'),pDur=$('pi-ts-durprop');
    if(!elGrid)return stub;

    var curDate='',taken={},start=null,dur=null,listener=null;
    var bookingId=tsNewId();          /* one id per page load - my own hold never blocks me */
    var heldDate='',heldHours=null;
    var ERR_DEFAULT=elErr?elErr.textContent:'';

    /* ── helpers ── */
    function money(n){return '$'+(Math.round(n*100)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
    function fmtH(h){var x=((h%24)+24)%24,ap=x<12?'AM':'PM',d=x%12;if(d===0)d=12;return d+':00 '+ap;}
    function to24(h,ap){h=parseInt(h,10);if(isNaN(h))return NaN;ap=(ap||'').toLowerCase();if(ap==='pm'&&h<12)h+=12;if(ap==='am'&&h===12)h=0;return h;}
    function parseOff(raw){
      var out=[];
      String(raw||'').split(',').forEach(function(seg){
        seg=seg.trim().toLowerCase(); if(!seg||seg==='none')return;
        var m=seg.match(/^(\d{1,2})(?::\d{2})?\s*(am|pm)?\s*(?:-|to|until|–|—)\s*(\d{1,2})(?::\d{2})?\s*(am|pm)?$/);
        if(!m)return;
        var a=to24(m[1],m[2]),b=to24(m[3],m[4]);
        if(isNaN(a)||isNaN(b))return;
        if(b<=a)b+=24;                       /* wraps past midnight, e.g. 22-7 */
        out.push([a,b]);
      });
      return out;
    }
    var OFF=parseOff(root.dataset.tsOff);
    function inRanges(list,h){for(var i=0;i<list.length;i++){var a=list[i][0],b=list[i][1];if((h>=a&&h<b)||(h+24>=a&&h+24<b))return true;}return false;}

    /* date-specific hour blocks:  "2026-08-14 12-16, 2026-12-24 to 2026-12-26 9-13, 2026-09-01 8-10;15-18" */
    function _iso2(dt){return dt.getFullYear()+'-'+String(dt.getMonth()+1).padStart(2,'0')+'-'+String(dt.getDate()).padStart(2,'0');}
    function parseSlotBlocks(raw){
      var map={};
      String(raw||'').split(',').forEach(function(entry){
        entry=entry.trim(); if(!entry||entry.toLowerCase()==='none')return;
        var m=entry.match(/^(\d{4}-\d{2}-\d{2})\s*(?:to|:|\.\.)\s*(\d{4}-\d{2}-\d{2})\s+(.+)$/i),d1,d2,hrs;
        if(m){d1=m[1];d2=m[2];hrs=m[3];}
        else{m=entry.match(/^(\d{4}-\d{2}-\d{2})\s+(.+)$/); if(!m)return; d1=m[1];d2=m[1];hrs=m[2];}
        var ranges=parseOff(String(hrs).replace(/[;&|]/g,','));
        if(!ranges.length)return;
        var c=new Date(d1+'T00:00:00'),e=new Date(d2+'T00:00:00'),g=0;
        if(isNaN(c.getTime())||isNaN(e.getTime()))return;
        while(c<=e&&g<400){var k=_iso2(c);map[k]=(map[k]||[]).concat(ranges);c.setDate(c.getDate()+1);g++;}
      });
      return map;
    }
    var BLOCKS=parseSlotBlocks(root.dataset.tsBlockedSlots);
    function dayBlocks(){return BLOCKS[curDate]||[];}
    function isDayBlocked(h){return inRanges(dayBlocks(),h);}
    function isOff(h){return inRanges(OFF,h)||isDayBlocked(h);}
    /* hours that fall in the gap after an existing booking */
    var bufMap={};
    function rebuildBuffer(){
      bufMap={};
      if(BUF<=0)return;
      for(var k in taken){
        if(!(taken[k]>0))continue;
        var h=parseInt(k,10); if(isNaN(h))continue;
        for(var i=1;i<=BUF;i++)bufMap[String(h+i)]=true;
      }
      for(var k2 in taken){if(taken[k2]>0)delete bufMap[String(k2)];}   /* a real booking is not a gap */
    }
    function isBuffer(h){return !!bufMap[String(h)];}
    function usedAt(h){return taken[String(h)]||0;}
    function leftAt(h){return Math.max(0,CAP-usedAt(h));}
    function isTaken(h){return usedAt(h)>=CAP;}
    function isBusy(h){return isOff(h)||isTaken(h)||isBuffer(h);}
    /* the visitor may sit in another timezone, so "now" has to be the STORE's now */
    function storeNow(){
      var m=String(root.dataset.storeOffset||'').match(/^([+-])(\d{2})(\d{2})$/);
      var d=new Date();
      if(!m)return d;                                   /* offset unknown - fall back to the browser */
      var off=(parseInt(m[2],10)*60+parseInt(m[3],10))*(m[1]==='-'?-1:1);
      return new Date(d.getTime()+(off+d.getTimezoneOffset())*60000);
    }
    function minStart(){
      if(curDate!==today)return DS;
      var n=storeNow();
      return Math.max(DS,n.getHours()+(n.getMinutes()>0?1:0)+LEAD);
    }
    function runFrom(h){var cap=Math.min(MIN+MAXX,DE-h),n=0;for(var i=0;i<cap;i++){if(isBusy(h+i))break;n++;}return n;}
    function isFree(h,d){if(h==null||!d)return false;if(h+d>DE)return false;for(var i=0;i<d;i++){if(isBusy(h+i))return false;}return h>=minStart();}
    function stateOf(h){
      if(h<minStart())return 'past';
      if(isDayBlocked(h))return 'dayoff';
      if(inRanges(OFF,h))return 'off';
      if(isTaken(h))return 'booked';
      if(isBuffer(h))return 'buffer';
      if(runFrom(h)<MIN)return 'short';
      return 'ok';
    }
    function hourList(){var a=[];for(var i=0;i<dur;i++)a.push(start+i);return a;}
    function clearProps(){if(pTime)pTime.value='';if(pDur)pDur.value='';}

    /* ── render ── */
    function renderGrid(){
      elGrid.innerHTML='';
      var any=false,frag=document.createDocumentFragment();
      for(var h=DS;h+MIN<=DE;h++){
        var st=stateOf(h),b=document.createElement('button'),tag='';
        b.type='button';b.className='pi-ts-slot';b.setAttribute('data-h',String(h));
        if(st==='ok'){
          any=true;
          var r=runFrom(h);
          tag='max '+r+'h';
          if(CAP>1){var lf=leftAt(h);tag=lf+' left · '+tag;if(lf===1)b.classList.add('is-last');}
        }
        else{
          b.disabled=true;
          if(st==='booked'){b.classList.add('is-booked');tag='Booked';}
          else if(st==='past'){tag='Passed';}
          else if(st==='buffer'){b.classList.add('is-buffer');tag='Lead time';}
          else if(st==='dayoff'){b.classList.add('is-dayoff');tag='Unavailable';}
          else if(st==='off'){tag='Closed';}
          else{tag='Too short';}
        }
        b.innerHTML='<span class="pi-ts-slot__t">'+fmtH(h)+'</span><span class="pi-ts-slot__tag">'+tag+'</span>';
        if(start===h)b.classList.add('is-selected');
        frag.appendChild(b);
      }
      elGrid.appendChild(frag);
      if(any)hide(elNone);else show(elNone);
    }
    function renderDurs(){
      if(!elDurs)return;
      elDurs.innerHTML='';
      if(start===null){hide(elDurW);return;}
      var run=runFrom(start),frag=document.createDocumentFragment(),bp=basePrice();
      for(var d=MIN;d<=run;d++){
        var sp=priceFor(d),extra=sp.extra,fee=sp.fee,b=document.createElement('button');
        b.type='button';b.className='pi-ts-dur';b.setAttribute('data-d',String(d));
        var right='';
        if(bp>0){
          right='<span class="pi-ts-dur__price">'+money(bp+fee)+'</span>';
        }else{
          right=extra>0?'<span class="pi-ts-dur__fee">'+(fee>0?'+'+money(fee):'+'+extra+'h')+'</span>':'<span class="pi-ts-dur__fee is-free">base price</span>';
        }
        b.innerHTML='<span class="pi-ts-dur__h">'+d+' hours'+(extra===0?'<em class="pi-ts-dur__base">included</em>':'')+'</span>'+right;
        if(extra>0&&FLAT&&(!sp.flat||!sp.flat.length))b.disabled=true;
        if(dur===d)b.classList.add('is-selected');
        frag.appendChild(b);
      }
      elDurs.appendChild(frag);
      show(elDurW);
    }
    function sync(){
      if(start===null||dur===null){clearProps();hide(elSum);return;}
      var end=start+dur,sp=priceFor(dur),fee=sp.fee;
      pTime.value=fmtH(start)+' – '+fmtH(end);
      pDur.value=dur+' hours';
      if(elSum){
        var bp=basePrice(),right;
        if(bp>0)right='<span class="pi-ts-summary__fee'+(fee>0?'':' is-free')+'">'+money(bp+fee)+'</span>';
        else right=fee>0?'<span class="pi-ts-summary__fee">+'+money(fee)+' added at checkout</span>':'<span class="pi-ts-summary__fee is-free">Standard price</span>';
        elSum.innerHTML='<span class="pi-ts-summary__ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></span>'+
          '<span class="pi-ts-summary__range">'+fmtH(start)+' – '+fmtH(end)+'</span>'+
          '<span class="pi-ts-summary__meta">'+dur+' hours total</span>'+right;
        show(elSum);
      }
    }
    function clearErr(){hide(elErr);wrap.classList.remove('pi-err');if(elErr)elErr.textContent=ERR_DEFAULT;}

    /* ── debug panel (section setting) ── */
    (function(){
      var dbg=$('pi-ts-debug'); if(!dbg)return;
      function line(k,v,bad){return '<div'+(bad?' class="is-bad"':'')+'><b>'+k+'</b><span>'+esc(String(v))+'</span></div>';}
      var h='';
      h+=line('Mode',FLAT?'FLAT (duration_fee_product)':'HOURLY (tier 1 / tier 2)');
      h+=line('Minimum hours',MIN);
      h+=line('Max extra hours',MAXX);
      h+=line('Gap after a booking',BUF===0?'none':BUF+'h (Lead time)');
      (function(){
        var n=storeNow(),p2=function(x){return (x<10?'0':'')+x;};
        h+=line('Store date / time',today+'  '+p2(n.getHours())+':'+p2(n.getMinutes())+'  (offset '+(root.dataset.storeOffset||'?')+')');
        h+=line('Same-day notice',LEAD+'h  \u2192 today opens at '+(function(){var v=Math.max(DS,n.getHours()+(n.getMinutes()>0?1:0)+LEAD);return v>=DE?'nothing left today':v+':00';})());
      })();
      h+=line('Calendar',SCOPE==='product'?'this product only':'shared by ALL products');
      h+=line('Firebase branch','slots/'+PID+'/<date>/<hour>');
      h+=line('Base price',money(basePrice()));
      if(FLAT){
        h+=line('Fee variants found',DURV.length,DURV.length===0);
        DURV.forEach(function(v){h+=line('&nbsp;&nbsp;up to '+v.h+'h',v.title+'  ->  '+money(v.price)+'  (id '+v.id+')');});
        h+=line('Stack buckets',STACK?'yes':'no');
      }else{
        h+=line('Tier 1 rate',money(FEE),!(FEE>0));
        h+=line('Tier 1 variant ID',FEE_VID||'MISSING',!FEE_VID);
        h+=line('Tier 2 rate',money(FEE2),!(FEE2>0));
        h+=line('Tier 2 variant ID',FEE_VID2||'MISSING - tier 2 is switched off',!FEE_VID2);
        h+=line('tier_after (raw)',root.dataset.tsTierAfter||'(empty)');
        h+=line('metafield keys found',root.dataset.tsKeys||'(none)',!root.dataset.tsKeys);
        h+=line('Tier 1 covers up to',TIERH===999?'ALL hours (no tier 2)':TIERH+'h total',TIERH===999);
        var tbl='';
        for(var d=MIN;d<=MIN+MAXX;d++){var sp=priceFor(d);
          tbl+=d+'h = '+money(basePrice()+sp.fee)+'  ('+sp.h1+'x'+money(FEE)+' + '+sp.h2+'x'+money(FEE2)+')\n';}
        h+='<pre>'+esc(tbl)+'</pre>';
      }
      dbg.innerHTML='<b class="pi-ts-debug__ttl">Time slot debug — turn this off before going live</b>'+h;
    })();

    /* ── interaction ── */
    elGrid.addEventListener('click',function(e){
      var b=e.target&&e.target.closest?e.target.closest('.pi-ts-slot'):null;
      if(!b||b.disabled)return;
      start=parseInt(b.getAttribute('data-h'),10);
      dur=MIN;
      clearErr();renderGrid();renderDurs();sync();
    });
    elDurs&&elDurs.addEventListener('click',function(e){
      var b=e.target&&e.target.closest?e.target.closest('.pi-ts-dur'):null;
      if(!b||b.disabled)return;
      dur=parseInt(b.getAttribute('data-d'),10);
      clearErr();renderDurs();sync();
    });

    /* ── data ── */
    function loadDate(d){
      if(listener){listener.off();listener=null;}
      curDate=d||'';start=null;dur=null;taken={};
      clearProps();clearErr();hide(elSum);hide(elDurW);hide(elNone);
      if(!curDate){hide(elBody);hide(elLoad);show(elEmpty);return;}
      hide(elEmpty);hide(elBody);show(elLoad);
      var first=true;
      listener=tsListen(PID,curDate,function(m){
        if(curDate!==d)return;
        taken=m||{};rebuildBuffer();
        if(first){first=false;hide(elLoad);show(elBody);}
        if(start!==null&&!isFree(start,dur||MIN)){start=null;dur=null;clearProps();hide(elSum);hide(elDurW);}
        renderGrid();renderDurs();
      },bookingId);
      setTimeout(function(){if(first&&curDate===d){first=false;hide(elLoad);show(elBody);renderGrid();}},7000);
    }

    /* ── public API ── */
    return {
      enabled:true,
      onDateChange:function(d){
        var blk=d&&(extraBlocked.indexOf(d)>-1||mfBlocked.indexOf(d)>-1);
        loadDate(blk?'':d);
      },
      reload:function(){loadDate(curDate);},
      refreshPrice:function(){renderDurs();sync();},
      validate:function(){
        if(start===null||dur===null){
          if(elErr)elErr.textContent=ERR_DEFAULT;
          show(elErr);wrap.classList.add('pi-err');
          wrap.scrollIntoView({behavior:'smooth',block:'center'});
          return false;
        }
        if(!isFree(start,dur)){
          start=null;dur=null;clearProps();hide(elSum);renderGrid();renderDurs();
          if(elErr)elErr.textContent='That time was just taken. Please pick another start time.';
          show(elErr);wrap.classList.add('pi-err');
          wrap.scrollIntoView({behavior:'smooth',block:'center'});
          return false;
        }
        clearErr();return true;
      },
      getExtra:function(){
        if(start===null||dur===null)return null;
        var sp=priceFor(dur);
        return {hours:sp.extra,flat:sp.flat,h1:sp.h1,h2:sp.h2,vid:FEE_VID,vid2:FEE_VID2,fee:sp.fee,total:dur};
      },
      rangeText:function(){return (start===null||dur===null)?'':(fmtH(start)+' – '+fmtH(start+dur));},
      /* three plain fields the Shopify Flow / webhook can read straight off the order,
         no splitting and no array indexing needed on their side */
      slotFields:function(){
        if(start===null||dur===null||!curDate)return null;
        return {
          '_Slot Product': String(PID),
          '_Slot Date':    curDate,
          '_Slot Hours':   hourList().join(',')
        };
      },
      reserve:function(){
        if(start===null||dur===null||!curDate)return Promise.resolve(false);
        if(!HOLD)return Promise.resolve(true);          /* no cart-stage hold - the order does the blocking */
        var hrs=hourList();
        /* drop the hold from a previous attempt so it can't linger on hours I no longer want */
        if(heldHours&&(heldDate!==curDate||heldHours.join()!==hrs.join()))tsRelease(PID,heldDate,heldHours,bookingId);
        heldDate=curDate;heldHours=hrs;
        return new Promise(function(res){
          var done=false;
          setTimeout(function(){if(!done){done=true;res(true);}},7000); /* never hard-block on a slow DB */
          tsReserve(PID,curDate,hrs,bookingId,CAP,function(ok){if(!done){done=true;res(ok);}});
        });
      },
      remember:function(){
        if(!HOLD)return;
        if(start===null||dur===null||!curDate||!bookingId)return;
        try{sessionStorage.setItem('pi_booked_slot',JSON.stringify({pid:PID,date:curDate,hours:hourList(),bid:bookingId}));}catch(e){}
      }
    };
  })();

  /* ════ SLOT BAR ════ */
  function updateSlotBar(info){if(!slotBar)return;var used=info.total,limit=info.limit;var pct=Math.min(100,Math.round((used/limit)*100));var rem=Math.max(0,limit-used);slotFill.style.width=pct+'%';if(pct>=100){slotFill.dataset.level='full';slotText.textContent='Fully booked';slotText.style.color='var(--danger)';}else if(pct>=67){slotFill.dataset.level='warn';slotText.textContent=rem+' spot'+(rem===1?'':'s')+' left!';slotText.style.color='var(--zip-warn)';}else{slotFill.dataset.level='ok';slotText.textContent=rem+' spot'+(rem===1?'':'s')+' left';slotText.style.color='var(--zip-ok)';}show(slotBar);}
  function hideAllDateNotices(){[noticeRegular,noticeSd,noticeHl,noticeBlocked,noticeLimit,noticeLoading,slotBar].forEach(hide);_dateBlocked=false;}
  var _fbListener=null;
  function startSlotPoll(date){if(_fbListener){_fbListener.off();_fbListener=null;}_fbListener=fbListenCount(date,function(c,i){if(!dateInp||dateInp.value!==date)return;var info={total:c,limit:DAILY_LIMIT,extra:(i&&i.extra)||0,main:(i&&i.main)||c};_lastSlotInfo=info;if(c>=DAILY_LIMIT){hideAllDateNotices();if(limitMsg)limitMsg.textContent='This date just became fully booked ('+c+'/'+DAILY_LIMIT+'). Please choose another date.';show(noticeLimit);_dateBlocked=true;}else updateSlotBar(info);});}
  function refreshDateNotices(val){
    hideAllDateNotices();TS.onDateChange(val);if(!val)return;
    var isSame=val===today;var isHol=allHols.indexOf(val)>-1&&!isSame;var isExtraB=(extraBlocked.indexOf(val)>-1||mfBlocked.indexOf(val)>-1)&&!isSame&&!isHol;
    if(isExtraB){show(noticeBlocked);_dateBlocked=true;return;}
    show(noticeLoading);
    getSlotInfo(val,DAILY_LIMIT).then(function(info){
      hide(noticeLoading);_lastSlotInfo=info;
      if(info.total>=info.limit){if(limitMsg)limitMsg.textContent='This date is fully booked ('+info.total+'/'+info.limit+' bookings). Please choose another date or contact us.';show(noticeLimit);_dateBlocked=true;return;}
      if(isSame)show(noticeSd);else if(isHol)show(noticeHl);else show(noticeRegular);
      updateSlotBar(info);startSlotPoll(val);
    });
  }
  dateInp&&dateInp.addEventListener('change',function(){_lastSlotInfo=null;refreshDateNotices(this.value);});

  /* ════ CUSTOM CALENDAR (design-matched, wired to slot/holiday/blocked) ════ */
  (function buildCalendar(){
    var trigger=$('pi-dt-trigger'),pop=$('pi-cal'),grid=$('pi-cal-grid'),lbl=$('pi-cal-label'),prevB=$('pi-cal-prev'),nextB=$('pi-cal-next'),phEl=$('pi-dt-ph'),valEl=$('pi-dt-val');
    if(!trigger||!grid)return;
    var MO=['January','February','March','April','May','June','July','August','September','October','November','December'];
    var tdy=new Date((today||'')+'T00:00:00');if(isNaN(tdy.getTime()))tdy=new Date();tdy.setHours(0,0,0,0);
    var vy=tdy.getFullYear(),vm=tdy.getMonth(),sel=null;
    function k2(y,m,d){return y+'-'+String(m+1).padStart(2,'0')+'-'+String(d).padStart(2,'0');}
    function isBlk(k){return extraBlocked.indexOf(k)>-1||mfBlocked.indexOf(k)>-1;}
    function atMin(){return vy===tdy.getFullYear()&&vm===tdy.getMonth();}
    function render(){
      lbl.textContent=MO[vm]+' '+vy;
      if(prevB)prevB.disabled=atMin();
      grid.innerHTML='';
      var first=new Date(vy,vm,1).getDay(),dim=new Date(vy,vm+1,0).getDate();
      for(var e=0;e<first;e++){var x=document.createElement('div');x.className='pi-cal-day is-empty';grid.appendChild(x);}
      for(var d=1;d<=dim;d++){
        var cd=new Date(vy,vm,d);cd.setHours(0,0,0,0);
        var k=k2(vy,vm,d),btn=document.createElement('button');
        btn.type='button';btn.textContent=d;btn.className='pi-cal-day';
        var past=cd.getTime()<tdy.getTime(),tod=cd.getTime()===tdy.getTime(),blk=isBlk(k);
        if(tod)btn.classList.add('is-today');
        if(sel===k)btn.classList.add('is-selected');
        if(past){btn.classList.add('is-disabled');btn.disabled=true;}
        else if(blk){btn.classList.add('is-blocked');btn.disabled=true;btn.title='Unavailable';}
        else{if(allHols.indexOf(k)>-1)btn.classList.add('is-holiday');btn.addEventListener('click',(function(kk,dd){return function(){pick(kk,dd);};})(k,cd));}
        grid.appendChild(btn);
      }
    }
    function fmt(dt){return dt.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'});}
    function pick(k,dt){sel=k;if(dateInp)dateInp.value=k;if(phEl)phEl.setAttribute('hidden','');if(valEl){valEl.textContent=fmt(dt);valEl.removeAttribute('hidden');}trigger.classList.remove('pi-dt-err');render();closeCal();_lastSlotInfo=null;refreshDateNotices(k);if(typeof XD!=='undefined'&&XD.onEventDateChange)XD.onEventDateChange(k);}
    function openCal(){pop.classList.add('is-open');trigger.classList.add('is-open');}
    function closeCal(){pop.classList.remove('is-open');trigger.classList.remove('is-open');}
    trigger.addEventListener('click',function(e){e.stopPropagation();pop.classList.contains('is-open')?closeCal():openCal();});
    prevB&&prevB.addEventListener('click',function(){if(atMin())return;vm--;if(vm<0){vm=11;vy--;}render();});
    nextB&&nextB.addEventListener('click',function(){vm++;if(vm>11){vm=0;vy++;}render();});
    document.addEventListener('click',function(e){if(pop.classList.contains('is-open')&&!pop.contains(e.target)&&!trigger.contains(e.target))closeCal();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCal();});
    render();
  })();


  /* ════ NEED EXTRA DAYS — second calendar, same rules as the event date ════ */
  var XD=(function(){
    var stub={enabled:false,active:function(){return false;},days:function(){return [];},
              fee:function(){return 0;},holFee:function(){return 0;},handle:function(){return '';},
              onEventDateChange:function(){},validate:function(){return true;},reset:function(){}};
    if(root.dataset.xdEnabled!=='true')return stub;
    var wrap=$('pi-xd');if(!wrap)return stub;

    var chk=$('pi-xd-chk'),body=$('pi-xd-body'),empty=$('pi-xd-empty'),picker=$('pi-xd-picker'),
        trigger=$('pi-xd-trigger'),pop=$('pi-xd-cal'),grid=$('pi-xd-grid'),lbl=$('pi-xd-label'),
        prevB=$('pi-xd-prev'),nextB=$('pi-xd-next'),phEl=$('pi-xd-ph'),valEl=$('pi-xd-val'),
        chips=$('pi-xd-chips'),loadEl=$('pi-xd-loading'),noteFull=$('pi-xd-note-full'),fullMsg=$('pi-xd-full-msg'),
        noteOk=$('pi-xd-note-ok'),okMsg=$('pi-xd-ok-msg'),noteHl=$('pi-xd-note-hl'),errEl=$('pi-xd-err'),
        propTxt=$('pi-xd-prop'),propRaw=$('pi-xd-raw');
    if(!chk||!grid)return stub;

    var MAX=parseInt(root.dataset.xdMax,10);if(isNaN(MAX)||MAX<1)MAX=3;
    function num(v){var n=parseFloat(String(v||'').replace(/[^0-9.]/g,''));return isNaN(n)?0:n;}
    var FEE=num(root.dataset.xdFee),HLFEE=num(root.dataset.holidayFee);
    var HANDLE=(root.dataset.xdHandle||'').trim(),HLHANDLE=(root.dataset.holidayHandle||'').trim();
    if(HANDLE==='none')HANDLE='';
    if(HLHANDLE==='none')HLHANDLE='';

    var MO=['January','February','March','April','May','June','July','August','September','October','November','December'];
    var sel=[],evKey='',vy=0,vm=0,busy=false;

    function k2(y,m,d){return y+'-'+String(m+1).padStart(2,'0')+'-'+String(d).padStart(2,'0');}
    function toDate(k){var d=new Date(k+'T00:00:00');d.setHours(0,0,0,0);return d;}
    function isBlk(k){return extraBlocked.indexOf(k)>-1||mfBlocked.indexOf(k)>-1;}
    function isHol(k){return allHols.indexOf(k)>-1;}
    function fmtLong(dt){return dt.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'});}
    function fmtShort(dt){return dt.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});}
    function money(n){return '$'+(Math.round(n*100)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
    function minDate(){if(!evKey)return null;var d=toDate(evKey);d.setDate(d.getDate()+1);return d;}
    function atMin(){var m=minDate();if(!m)return true;return vy===m.getFullYear()&&vm===m.getMonth();}

    function render(){
      var m=minDate();if(!m)return;
      lbl.textContent=MO[vm]+' '+vy;
      if(prevB)prevB.disabled=atMin();
      grid.innerHTML='';
      var first=new Date(vy,vm,1).getDay(),dim=new Date(vy,vm+1,0).getDate();
      for(var e=0;e<first;e++){var x=document.createElement('div');x.className='pi-cal-day is-empty';grid.appendChild(x);}
      for(var d=1;d<=dim;d++){
        var cd=new Date(vy,vm,d);cd.setHours(0,0,0,0);
        var k=k2(vy,vm,d),btn=document.createElement('button');
        btn.type='button';btn.textContent=d;btn.className='pi-cal-day';
        if(k===evKey){btn.classList.add('is-event');btn.disabled=true;btn.title='Your event date';grid.appendChild(btn);continue;}
        var before=cd.getTime()<m.getTime(),blk=isBlk(k),hol=isHol(k),picked=sel.indexOf(k)>-1;
        if(hol)btn.classList.add('is-holiday');
        if(before){btn.classList.add('is-disabled');btn.disabled=true;}
        else if(blk){btn.classList.add('is-blocked');btn.disabled=true;btn.title='Unavailable';}
        else{
          if(picked)btn.classList.add('is-picked');
          btn.addEventListener('click',(function(kk,dd){return function(){toggle(kk,dd);};})(k,cd));
        }
        grid.appendChild(btn);
      }
    }

    function syncOut(){
      var txt=[],raw=[];
      sel.slice().sort().forEach(function(k){
        var dt=toDate(k),hol=isHol(k);
        txt.push(fmtShort(dt)+(hol?' (Holiday)':''));
        raw.push(k);
      });
      if(propTxt)propTxt.value=txt.join(', ');
      if(propRaw)propRaw.value=raw.join(',');
      if(valEl){if(raw.length){valEl.textContent=raw.length+' extra day'+(raw.length===1?'':'s')+' selected';valEl.removeAttribute('hidden');phEl&&phEl.setAttribute('hidden','');}
                else{valEl.setAttribute('hidden','');phEl&&phEl.removeAttribute('hidden');}}
      renderChips();
      var anyHol=sel.some(isHol);
      if(anyHol)show(noteHl);else hide(noteHl);
      if(sel.length){
        var total=0;sel.forEach(function(k){total+=isHol(k)?HLFEE:FEE;});
        if(okMsg)okMsg.textContent=sel.length+' extra day'+(sel.length===1?'':'s')+' added — '+money(total)+' will be added to your cart.';
        show(noteOk);
      }else hide(noteOk);
      if(sel.length)hide(errEl);
      wrap.classList.remove('pi-err');
      if(typeof buildTotals==='function')buildTotals();
    }

    function renderChips(){
      if(!chips)return;
      chips.innerHTML='';
      sel.slice().sort().forEach(function(k){
        var dt=toDate(k),hol=isHol(k),fee=hol?HLFEE:FEE;
        var c=document.createElement('span');
        c.className='pi-xd-chip'+(hol?' is-holiday':'');
        c.innerHTML='<span>'+esc(fmtShort(dt))+(hol?' · Holiday':'')+'</span>'+
                    '<span class="pi-xd-chip__fee">'+esc(money(fee))+'</span>'+
                    '<button type="button" class="pi-xd-chip__x" aria-label="Remove day">'+
                    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
        c.querySelector('.pi-xd-chip__x').addEventListener('click',function(){
          sel=sel.filter(function(x){return x!==k;});hide(noteFull);render();syncOut();
        });
        chips.appendChild(c);
      });
    }

    /* same real-time daily-limit check the event date uses */
    function toggle(k,dt){
      if(busy)return;
      hide(noteFull);
      if(sel.indexOf(k)>-1){sel=sel.filter(function(x){return x!==k;});render();syncOut();return;}
      if(sel.length>=MAX){
        if(fullMsg)fullMsg.textContent='You can add up to '+MAX+' extra day'+(MAX===1?'':'s')+'. Remove one first.';
        show(noteFull);return;
      }
      busy=true;show(loadEl);
      var guard=new Promise(function(res){setTimeout(function(){res({total:0,limit:DAILY_LIMIT});},5000);});
      Promise.race([getSlotInfo(k,DAILY_LIMIT),guard]).then(function(info){
        busy=false;hide(loadEl);
        if(info.total>=info.limit){
          if(fullMsg)fullMsg.textContent=fmtLong(dt)+' is fully booked ('+info.total+'/'+info.limit+'). Please pick a different day.';
          show(noteFull);return;
        }
        sel.push(k);render();syncOut();
      }).catch(function(){busy=false;hide(loadEl);sel.push(k);render();syncOut();});
    }

    function openCal(){pop.classList.add('is-open');trigger.classList.add('is-open');}
    function closeCal(){pop.classList.remove('is-open');trigger.classList.remove('is-open');}
    trigger&&trigger.addEventListener('click',function(e){e.stopPropagation();pop.classList.contains('is-open')?closeCal():openCal();});
    prevB&&prevB.addEventListener('click',function(){if(atMin())return;vm--;if(vm<0){vm=11;vy--;}render();});
    nextB&&nextB.addEventListener('click',function(){vm++;if(vm>11){vm=0;vy++;}render();});
    document.addEventListener('click',function(e){if(pop.classList.contains('is-open')&&!pop.contains(e.target)&&!trigger.contains(e.target))closeCal();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCal();});

    chk.addEventListener('change',function(){
      if(chk.checked){show(body);}
      else{hide(body);sel=[];closeCal();hide(noteFull);syncOut();}
    });

    function reset(){sel=[];closeCal();hide(noteFull);syncOut();}

    return {
      enabled:true,
      active:function(){return chk.checked&&sel.length>0;},
      checked:function(){return chk.checked;},
      count:function(){return sel.length;},
      fee:function(){return FEE;},
      holFee:function(){return HLFEE;},
      handle:function(){return HANDLE;},
      holHandle:function(){return HLHANDLE;},
      days:function(){
        return sel.slice().sort().map(function(k){
          var hol=isHol(k);
          return {date:k,hol:hol,fee:hol?HLFEE:FEE,label:fmtShort(toDate(k)),long:fmtLong(toDate(k))};
        });
      },
      onEventDateChange:function(k){
        evKey=k||'';
        sel=[];hide(noteFull);closeCal();
        if(!evKey){hide(picker);show(empty);syncOut();return;}
        hide(empty);show(picker);
        var m=minDate();vy=m.getFullYear();vm=m.getMonth();
        render();syncOut();
      },
      validate:function(){
        if(!chk.checked)return true;
        if(sel.length>0)return true;
        show(errEl);wrap.classList.add('pi-err');
        wrap.scrollIntoView({behavior:'smooth',block:'center'});
        return false;
      },
      reset:reset
    };
  })();

  /* ════ STEP NAV ════ */
  function goStep(n){[s1,s2].forEach(function(p,i){if(!p)return;p.classList.toggle('pi-panel--hidden',(i+1)!==n);p.setAttribute('aria-hidden',String((i+1)!==n));});stepEls.forEach(function(el){var s=parseInt(el.dataset.step,10);el.classList.toggle('pi-step--active',s===n);el.classList.toggle('pi-step--done',s<n);});if(pdForm)pdForm.style.display=(n===2)?'none':'';root.scrollIntoView({behavior:'smooth',block:'nearest'});}

  nextBtn&&nextBtn.addEventListener('click',function(){
    var agreeChk=$('pi-agree'),agreeErr=$('pi-agree-err');
    if(agreeChk&&!agreeChk.checked){if(agreeErr)agreeErr.removeAttribute('hidden');var t=$('pi-agr-open');if(t)t.scrollIntoView({behavior:'smooth',block:'center'});return;}
    if(agreeErr)agreeErr.setAttribute('hidden','');
    if(!dateInp||!dateInp.value){var _tg=$('pi-dt-trigger');if(_tg){_tg.classList.add('pi-dt-err');_tg.scrollIntoView({behavior:'smooth',block:'center'});}return;}
    if(_dateBlocked){if(dateInp){dateInp.classList.add('pi-err');dateInp.scrollIntoView({behavior:'smooth',block:'center'});}alert('The selected date is unavailable. Please choose a different date.');return;}
    if(!TS.validate())return;
    var ok=true;
    s1.querySelectorAll('.pi-swatch-row[data-required="true"]').forEach(function(row){if(row.closest('.pi-field--vhidden,.pi-field--sw-hidden'))return;var inp=document.getElementById(row.dataset.target);var field=row.closest('.pi-field');var errEl=field?field.querySelector('.pi-err-msg'):null;if(inp&&!inp.value.trim()){row.classList.add('pi-err');if(errEl)errEl.removeAttribute('hidden');ok=false;}});
    s1.querySelectorAll('[required]').forEach(function(f){if(f.closest('.pi-field--vhidden,.pi-field--sw-hidden')){f.classList.remove('pi-err');return;}f.classList.remove('pi-err');var valid=f.type==='radio'?!!s1.querySelector('[name="'+f.name+'"]:checked'):f.value.trim()!=='';if(!valid){f.classList.add('pi-err');ok=false;}f.addEventListener('input',function(){f.classList.remove('pi-err');},{once:true});f.addEventListener('change',function(){f.classList.remove('pi-err');},{once:true});});
    s1.querySelectorAll('input[type="tel"]').forEach(function(t){
      if(t.closest('.pi-field--vhidden,.pi-field--sw-hidden'))return;
      if(t.dataset.phoneOk==='0'){t.classList.add('pi-err');ok=false;}
    });
    if(typeof XD!=='undefined'&&XD.validate&&!XD.validate())return;
    if(!ok){var first=s1.querySelector('.pi-err,.pi-swatch-row.pi-err');if(first)first.scrollIntoView({behavior:'smooth',block:'center'});return;}
    buildReview();goStep(2);
  });
  backBtn&&backBtn.addEventListener('click',function(){goStep(1);});

  function buildReview(){
    varId=getCurrentVarId(varId);
    var pe=$('pi-review-price');
    if(pe){var lp=_currentVariantPrice;if(lp==null){var pr=document.querySelector('.price__regular .price-item--regular,.price__sale .price-item--sale');if(pr&&pr.textContent.trim()){pe.textContent=pr.textContent.trim();lp=-1;}}if(lp!=null&&lp>=0)pe.textContent='$'+(lp/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
    if(rrows){var seen={},html='';s1.querySelectorAll('[name^="properties["]').forEach(function(inp){if(inp.closest('.pi-field--vhidden,.pi-field--sw-hidden'))return;if(inp.type==='radio'&&!inp.checked)return;var key=inp.name.slice(11,-1),val=inp.value.trim();if(!val||seen[key])return;seen[key]=true;html+='<div class="pi-rrow"><dt>'+esc(key)+'</dt><dd>'+esc(val)+'</dd></div>';});rrows.innerHTML=html;}
    var dv=dateInp?dateInp.value:'';var isSame=dv===today;var isHol=allHols.indexOf(dv)>-1&&!isSame;var any=false;
    [noteRegular2,noteSd2,noteHl2,noteSlot].forEach(hide);
    if(dv){if(isSame){show(noteSd2);any=true;}else if(isHol){show(noteHl2);any=true;}else{show(noteRegular2);any=true;}}
    if(noteSlot&&_lastSlotInfo){var info=_lastSlotInfo;var rem=Math.max(0,info.limit-info.total);if(info.total>=info.limit){noteSlotBadge.className='pi-badge pi-badge--slot-full';noteSlotBadge.textContent='Date fully booked';noteSlotText.textContent='Please go back and choose another date.';noteSlot.className='pi-note-badge pi-note-badge--slot';}else if(rem<=2){noteSlotBadge.className='pi-badge pi-badge--slot-warn';noteSlotBadge.textContent='Only '+rem+' spot'+(rem===1?'':'s')+' left!';noteSlotText.textContent='Limited availability — book now to secure your date!';noteSlot.className='pi-note-badge pi-note-badge--slot warn';}else{noteSlotBadge.className='pi-badge pi-badge--slot-ok';noteSlotBadge.textContent=rem+' spot'+(rem===1?'':'s')+' left';noteSlotText.textContent='Book now to secure your date!';noteSlot.className='pi-note-badge pi-note-badge--slot ok';}show(noteSlot);any=true;}
    if(noteWrap){any?show(noteWrap):hide(noteWrap);}
    buildTotals();
  }

  /* ════ ORDER TOTAL — holiday + delivery + same-day + hours ════ */
  function _m(n){return '$'+(Math.round(n*100)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function _feeNum(v){var n=parseFloat(String(v||'').replace(/[^0-9.]/g,''));return isNaN(n)?0:n;}

  /* single source of truth for every price line */
  function computeTotals(){
    var dv=dateInp?dateInp.value:'';
    var isSame=dv===today;
    var isHol=allHols.indexOf(dv)>-1&&!isSame;
    var base=(typeof _currentVariantPrice==='number'&&_currentVariantPrice>=0)
             ?_currentVariantPrice/100
             :(parseInt(root.dataset.variantPrice,10)||0)/100;
    var E=TS.getExtra();
    var extraFee=(E&&E.fee>0)?E.fee:0;
    var rows=[],total=0;
    function add(label,sub,amount,cls){rows.push({label:label,sub:sub||'',amount:amount,cls:cls||''});total+=amount;}

    /* the product itself first, so it lines up with the price shown on the cart row */
    add((root.dataset.productTitle||'Yard greeting'),
        (E?(MINH()+' hours included'):''),base);

    if(E&&E.hours>0)
      add('Extra time',E.hours+' extra hour'+(E.hours===1?'':'s')+' · '+E.total+' hours total',extraFee,extraFee>0?'is-fee':'is-free');

    var D=window['piDist_'+sid];
    if(D&&D.ok&&!D.outside)
      add((D.label||'Delivery'),(D.miles?D.miles+' mi drive':''),D.fee||0,(D.fee>0?'is-fee':'is-free'));

    var sdFee=_feeNum(root.dataset.sameDayFee);
    if(isSame&&sdHandle&&sdHandle.trim()&&sdHandle!=='none'&&sdFee>0)
      add('Same-day setup fee','Booked for today',sdFee,'is-fee');

    var hlFee=_feeNum(root.dataset.holidayFee);
    if(isHol&&hlHandle&&hlHandle.trim()&&hlHandle!=='none'&&hlFee>0)
      add('Holiday fee','Booked on a holiday date',hlFee,'is-fee');

    /* extra days — normal rate, and the holiday rate for any day that lands on a holiday */
    var XDdays=(typeof XD!=='undefined'&&XD.days)?XD.days():[];
    if(XDdays.length){
      var xNorm=XDdays.filter(function(d){return !d.hol;});
      var xHol=XDdays.filter(function(d){return d.hol;});
      if(xNorm.length&&XD.fee()>0)
        add('Extra day'+(xNorm.length===1?'':'s'),
            xNorm.map(function(d){return d.label;}).join(', '),
            xNorm.length*XD.fee(),'is-fee');
      if(xHol.length&&XD.holFee()>0)
        add('Extra day'+(xHol.length===1?'':'s')+' (holiday)',
            xHol.map(function(d){return d.label;}).join(', '),
            xHol.length*XD.holFee(),'is-fee');
    }

    return {rows:rows,total:total,hasDate:!!dv};
  }
  function MINH(){var E=TS.getExtra();return E?(E.total-E.hours):'';}

  function buildTotals(){
    if(!totalBox)return;
    var t=computeTotals();
    if(!t.hasDate){hide(totalBox);return;}
    var html='';
    t.rows.forEach(function(r){
      html+='<div class="pi-total__row'+(r.cls?' '+r.cls:'')+'"><span>'+esc(r.label)+
            (r.sub?'<small>'+esc(r.sub)+'</small>':'')+'</span><b>'+
            (r.amount>0?_m(r.amount):'Free')+'</b></div>';
    });
    html+='<div class="pi-total__row pi-total__row--grand"><span>Total</span><b>'+_m(t.total)+'</b></div>';
    html+='<p class="pi-total__note">Taxes and any discounts are applied at checkout.</p>';
    totalBox.innerHTML=html;
    show(totalBox);
  }

  /* the same breakdown, written onto the main line item so the cart can show it */
  function totalProps(){
    var t=computeTotals(),out={};
    t.rows.forEach(function(r){
      var k=r.label+(r.sub?' ('+r.sub+')':'');
      out[k]=(r.amount>0?_m(r.amount):'Free');
    });
    out['Order total']=_m(t.total);
    return out;
  }

  /* ════ BOOK ════ */
  function fetchVariant(handle){return fetch('/products/'+handle+'.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){return(p&&p.variants&&p.variants[0])?p.variants[0]:null;}).catch(function(){return null;});}
  bookBtn&&bookBtn.addEventListener('click',function(){
    varId=getCurrentVarId(varId);
    if(!varId||isNaN(varId)){alert('Product configuration error. Please refresh and try again.');return;}
    var dv=dateInp?dateInp.value:'';var isSame=dv===today;var isHol=allHols.indexOf(dv)>-1&&!isSame;var isExtraB=(extraBlocked.indexOf(dv)>-1||mfBlocked.indexOf(dv)>-1)&&!isSame&&!isHol;
    if(isExtraB||_dateBlocked){alert('This date is unavailable. Please go back and choose a different date.');return;}
    if(!TS.validate()){goStep(1);return;}
    var idle=bookBtn.querySelector('.pi-btn__idle'),busy=bookBtn.querySelector('.pi-btn__busy');
    bookBtn.disabled=true;if(idle)idle.setAttribute('hidden','');if(busy)busy.removeAttribute('hidden');
    var _slotGuard=new Promise(function(res){setTimeout(function(){res({total:0,limit:DAILY_LIMIT});},5000);});
    Promise.race([getSlotInfo(dv,DAILY_LIMIT),_slotGuard]).then(function(info){
      if(info.total>=info.limit){bookBtn.disabled=false;if(idle)idle.removeAttribute('hidden');if(busy)busy.setAttribute('hidden','');alert('Sorry — this date just became fully booked. Please choose another date.');hideAllDateNotices();if(limitMsg)limitMsg.textContent='This date is fully booked.';show(noticeLimit);_dateBlocked=true;goStep(1);return;}
      var props={};
      s1.querySelectorAll('[name^="properties["]').forEach(function(inp){if(inp.closest('.pi-field--vhidden,.pi-field--sw-hidden'))return;if(inp.type==='radio'&&!inp.checked)return;var key=inp.name.slice(11,-1),val=inp.value.trim();if(val)props[key]=val;});
      var lname=props['Name of Person']||props['Baby Name']||props['Couple Names']||(function(){for(var k in props){if(props[k])return props[k];}return '';})();
      var items=[{id:varId,quantity:1,properties:props}];
      /* ── collect selected add-ons now so they go into the batch add ── */
      root.querySelectorAll('.pi-addon-chk:checked').forEach(function(chk){
        var vid=parseInt(chk.dataset.variantId,10);
        if(vid&&!isNaN(vid))items.push({id:vid,quantity:1,properties:{'_Linked Order':lname}});
      });
      function doNativeAdd(){if(CLEAR_CART){try{fetch('/cart/clear.js',{method:'POST',keepalive:true,headers:{'X-Requested-With':'XMLHttpRequest'}});}catch(e){}}var fm=document.createElement('form');fm.method='post';fm.action=CART_ADD;fm.acceptCharset='UTF-8';fm.style.display='none';function af(n,v){var i=document.createElement('input');i.type='hidden';i.name=n;i.value=v;fm.appendChild(i);}af('id',varId);af('quantity','1');for(var k in props){if(props[k])af('properties['+k+']',props[k]);}af('return_to',CHECKOUT_URL);document.body.appendChild(fm);try{TS.remember();sessionStorage.setItem('pi_booked_date',dv);}catch(e){}fm.submit();}
      function addItemForm(item){
        var fd=new FormData();fd.append('id',item.id);fd.append('quantity',item.quantity||1);
        var p=item.properties||{};for(var k in p){if(p[k]!=null&&p[k]!=='')fd.append('properties['+k+']',p[k]);}
        return fetch(CART_ADD+'.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:fd})
          .then(function(res){if(!res.ok)return res.text().then(function(t){var m='Booking failed ('+res.status+').';try{var j=JSON.parse(t);m=(j.description||j.message||m);}catch(e){}throw new Error(m);});return res.json();});
      }
      function addMain(n){
        return addItemForm(items[0]).catch(function(err){var net=(''+(err&&err.message||'')).toLowerCase().indexOf('failed to fetch')>-1;if(net&&n<2){return new Promise(function(r){setTimeout(r,700);}).then(function(){return addMain(n+1);});}throw err;});
      }
      function addFees(){var pr=Promise.resolve();for(var i=1;i<items.length;i++){(function(it){pr=pr.then(function(){return addItemForm(it).catch(function(){});});})(items[i]);}return pr;}
      var XDdays=(typeof XD!=='undefined'&&XD.days)?XD.days():[];
      Promise.resolve()
        .then(function(){
          /* every extra day is checked live, exactly like the event date */
          if(!XDdays.length)return;
          return Promise.all(XDdays.map(function(d){
            var g=new Promise(function(res){setTimeout(function(){res({total:0,limit:DAILY_LIMIT});},5000);});
            return Promise.race([getSlotInfo(d.date,DAILY_LIMIT),g]);
          })).then(function(arr){
            for(var i=0;i<arr.length;i++){
              if(arr[i].total>=arr[i].limit)throw new Error('__XD_FULL__|'+XDdays[i].long);
            }
          });
        })
        .then(function(){return TS.reserve();})
        .then(function(okSlot){if(okSlot===false)throw new Error('__TS_CONFLICT__');})
        .then(function(){if(isSame&&sdHandle&&sdHandle.trim()&&sdHandle!=='none')return fetchVariant(sdHandle).then(function(v){if(v)items.push({id:v.id,quantity:1,properties:{'_Linked Order':lname,'_fee':'1'}});});})
        .then(function(){if(isHol&&hlHandle&&hlHandle.trim()&&hlHandle!=='none')return fetchVariant(hlHandle).then(function(v){if(v)items.push({id:v.id,quantity:1,properties:{'_Linked Order':lname,'_fee':'1'}});});})
        .then(function(){
          /* extra days: normal handle for ordinary days, the holiday handle for holiday days */
          if(!XDdays.length)return;
          var xNorm=XDdays.filter(function(d){return !d.hol;});
          var xHol=XDdays.filter(function(d){return d.hol;});
          var pr=Promise.resolve();
          if(xNorm.length&&XD.handle()){
            pr=pr.then(function(){return fetchVariant(XD.handle()).then(function(v){
              if(v)items.push({id:v.id,quantity:xNorm.length,properties:{
                '_Linked Order':lname,
                'Extra Days':xNorm.map(function(d){return d.label;}).join(', '),
                '_Slot Extra Dates':xNorm.map(function(d){return d.date;}).join(','),
                '_fee':'1'}});
            }).catch(function(){});});
          }
          if(xHol.length&&XD.holHandle()){
            pr=pr.then(function(){return fetchVariant(XD.holHandle()).then(function(v){
              if(v)items.push({id:v.id,quantity:xHol.length,properties:{
                '_Linked Order':lname,
                'Extra Days (holiday)':xHol.map(function(d){return d.label;}).join(', '),
                '_Slot Extra Dates':xHol.map(function(d){return d.date;}).join(','),
                '_fee':'1'}});
            }).catch(function(){});});
          }
          return pr;
        })
        .then(function(){var D=window['piDist_'+sid];if(D&&D.ok&&!D.outside&&D.fee>0&&D.handle)return fetchVariant(D.handle).then(function(v){if(v)items.push({id:v.id,quantity:1,properties:{'_Linked Order':lname,'_Delivery Zone':D.label,'_Delivery Distance':D.miles+' mi','_fee':'1'}});});})
        .then(function(){
          var E=TS.getExtra();if(!E||E.hours<=0)return;
          var totalTxt=E.total+' hours';
          function feeProps(){return {'_Linked Order':lname,'Setup Time':TS.rangeText(),'Total Time':totalTxt,'_fee':'1'};}
          if(E.flat&&E.flat.length){
            E.flat.forEach(function(fv){items.push({id:fv.id,quantity:1,properties:feeProps()});});
            return;
          }
          if(E.h1>0&&E.vid)items.push({id:E.vid,quantity:E.h1,properties:feeProps()});
          if(E.h2>0&&E.vid2)items.push({id:E.vid2,quantity:E.h2,properties:feeProps()});
        })
        .then(function(){
          /* wipe whatever was in the cart so a booking is never mixed with an older one */
          if(!CLEAR_CART)return;
          return fetch('/cart/clear.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'}}).catch(function(){});
        })
        .then(function(){
          /* stamp the full price breakdown on the main line so the cart can show one clean item */
          var tp=totalProps();
          for(var k in tp){if(tp[k])items[0].properties[k]=tp[k];}
          /* hidden fields the order automation uses to block the time slot in Firebase:
               _Slot Product  51485246488882
               _Slot Date     2026-07-31
               _Slot Hours    8,9,10,11        (24-hour clock, one entry per booked hour) */
          var sf=TS.slotFields();
          if(sf){for(var sk in sf){if(sf[sk])items[0].properties[sk]=sf[sk];}}
        })
        .then(function(){return addMain(0);})
        .then(addFees)
        .then(function(){TS.remember();sessionStorage.setItem('pi_booked_date',dv);if(_fbListener){_fbListener.off();_fbListener=null;}window.location.href=CHECKOUT_URL;})
        .catch(function(err){
          if(err&&(''+err.message).indexOf('__XD_FULL__')===0){
            bookBtn.disabled=false;if(idle)idle.removeAttribute('hidden');if(busy)busy.setAttribute('hidden','');
            goStep(1);
            alert('Sorry \u2014 '+(''+err.message).split('|')[1]+' just became fully booked. Please pick a different extra day.');
            return;
          }
          if(err&&err.message==='__TS_CONFLICT__'){bookBtn.disabled=false;if(idle)idle.removeAttribute('hidden');if(busy)busy.setAttribute('hidden','');TS.reload();goStep(1);alert('Sorry \u2014 that time slot was just booked by someone else. Please choose another start time.');return;}
          var net=(''+(err&&err.message||'')).toLowerCase().indexOf('failed to fetch')>-1;if(net){try{doNativeAdd();return;}catch(e){}}bookBtn.disabled=false;if(idle)idle.removeAttribute('hidden');if(busy)busy.setAttribute('hidden','');alert(net?'Could not reach the store. Please disable any ad-blocker / VPN / privacy extension and try again.':('Something went wrong: '+(err.message||'Please try again.')));});
    });
  });
});

/* ══ AGREEMENT INLINE ACCORDION ══ */
document.querySelectorAll('[id^="pi-agr-toggle-"]').forEach(function(toggleBtn){
  var sid=toggleBtn.id.replace('pi-agr-toggle-','');
  var panel=document.getElementById('pi-agr-panel-'+sid);
  var mainChk=document.getElementById('pi-agree-'+sid);
  var badge=document.getElementById('pi-agr-badge-'+sid);
  var errEl=document.getElementById('pi-agree-err-'+sid);
  var progressEl=document.getElementById('pi-agr-progress-'+sid);
  if(!panel)return;

  /* open / close */
  function setOpen(open){
    toggleBtn.setAttribute('aria-expanded',open?'true':'false');
    panel.setAttribute('aria-hidden',open?'false':'true');
  }
  toggleBtn.addEventListener('click',function(){
    setOpen(toggleBtn.getAttribute('aria-expanded')==='false');
  });

  /* recalculate state after any checkbox change */
  function updateState(){
    var allChk=panel.querySelectorAll('.pi-agr-item-chk');
    var reqChk=panel.querySelectorAll('.pi-agr-item-chk[data-required="true"]');
    var reqDone=0;
    reqChk.forEach(function(c){if(c.checked)reqDone++;});
    var totalReq=reqChk.length;
    var allReqAccepted=totalReq===0||reqDone===totalReq;

    /* progress text */
    if(progressEl){
      if(totalReq===0){
        progressEl.textContent='No required items';
      } else {
        progressEl.textContent=reqDone+' of '+totalReq+' required item'+(totalReq===1?'':'s')+' accepted';
      }
    }

    /* master hidden checkbox drives submit validation */
    if(mainChk)mainChk.checked=allReqAccepted;

    /* badge label + colour */
    if(badge){
      if(allReqAccepted&&(totalReq>0||allChk.length===0)){
        badge.textContent='Accepted';
        badge.classList.add('accepted');
      } else {
        badge.textContent=totalReq>0?'Required':'Optional';
        badge.classList.remove('accepted');
      }
    }

    /* hide validation error once resolved */
    if(allReqAccepted&&errEl)errEl.setAttribute('hidden','');
  }

  panel.addEventListener('change',function(e){
    if(e.target.classList.contains('pi-agr-item-chk')){
      /* open the panel on first interaction if somehow closed */
      setOpen(true);
      updateState();
    }
  });

  /* initial state on page load */
  updateState();
});

/* ══ REACTIVE CONTINUE BUTTON ══
   Gates: event date selected + delivery address confirmed + agreement accepted.
   All three must be green before the Next button enables.
══════════════════════════════════ */
document.querySelectorAll('[id^="pi-booking-"]').forEach(function(root){
  var sid     = root.id.replace('pi-booking-','');
  var nextBtn = document.getElementById('pi-next-' + sid);
  var dateInp = document.getElementById('pi-date-' + sid);
  var distProp= document.getElementById('pi-dist-prop-' + sid);
  var agrChk  = document.getElementById('pi-agree-' + sid);
  if(!nextBtn) return;

  function gate(){
    var hasDate  = !!(dateInp && dateInp.value);
    var addrOk   = !!(distProp && distProp.value && distProp.value.trim());
    var agrOk    = !agrChk || agrChk.checked;
    var ready    = hasDate && addrOk && agrOk;
    nextBtn.disabled = !ready;
    nextBtn.setAttribute('aria-disabled', String(!ready));
    /* tooltip hint for the customer */
    if(!ready){
      nextBtn.title = !hasDate  ? 'Please select an event date first'
                    : !addrOk  ? 'Please confirm your delivery address'
                    :            'Please accept the booking agreement';
    } else {
      nextBtn.removeAttribute('title');
    }
  }

  /* watch event date */
  if(dateInp) dateInp.addEventListener('change', gate);

  /* watch address confirmation via MutationObserver on distProp hidden field */
  if(distProp){
    var distObs = new MutationObserver(gate);
    distObs.observe(distProp, {attributes:true});
    /* also watch normal input/change (programmatic value change fires these in some browsers) */
    distProp.addEventListener('input',  gate);
    distProp.addEventListener('change', gate);
    /* intercept the distance-check updates that set distProp.value programmatically */
    var _origDistVal = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value');
    if(_origDistVal){
      try{
        Object.defineProperty(distProp,'value',{
          get:function(){return _origDistVal.get.call(this);},
          set:function(v){_origDistVal.set.call(this,v);gate();}
        });
      }catch(e){}
    }
  }

  /* watch agreement checkboxes */
  var agrPanel = document.getElementById('pi-agr-panel-' + sid);
  if(agrPanel) agrPanel.addEventListener('change', gate);

  /* watch all required inputs in case they have been pre-filled by user */
  root.addEventListener('input',  function(e){if(e.target.closest('#pi-s1-'+sid)) gate();});
  root.addEventListener('change', function(e){if(e.target.closest('#pi-s1-'+sid)) gate();});

  /* initial evaluation */
  gate();
});

/* ══ INLINE ADD-ONS — accordion + variant-select + price tracker ══
   Runs once when step 2 is first shown (goStep triggers a custom event).
   No cart interaction — selections are collected at book-button click time.
══════════════════════════════════════════════════════════════════════ */
document.querySelectorAll('[id^="pi-booking-"]').forEach(function(root){
  var sid = root.id.replace('pi-booking-','');
  var s2  = document.getElementById('pi-s2-' + sid);
  var nextBtn = document.getElementById('pi-next-' + sid);
  if (!s2 || !nextBtn) return;

  var addonInitDone = false;

  function initAddons() {
    if (addonInitDone) return;
    addonInitDone = true;

    /* ── Category accordion ── */
    s2.querySelectorAll('[data-cat-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = btn.closest('[data-cat]');
        var wasOpen = cat.classList.contains('is-open');
        s2.querySelectorAll('[data-cat]').forEach(function(c) {
          c.classList.remove('is-open');
          var b = c.querySelector('[data-cat-toggle]');
          if (b) b.setAttribute('aria-expanded','false');
        });
        if (!wasOpen) {
          cat.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
        }
      });
    });

    /* ── Open first category by default ── */
    var firstCat = s2.querySelector('[data-cat]');
    if (firstCat) {
      firstCat.classList.add('is-open');
      var firstBtn = firstCat.querySelector('[data-cat-toggle]');
      if (firstBtn) firstBtn.setAttribute('aria-expanded','true');
    }

    /* ── Variant selects — sync price display + checkbox variant id ── */
    s2.querySelectorAll('[data-addon-variant-select]').forEach(function(sel) {
      sel.addEventListener('change', function(e) {
        var key      = e.target.dataset.prod;
        var opt      = e.target.options[e.target.selectedIndex];
        var newPrice = parseInt(opt.dataset.price, 10) || 0;
        var newVid   = opt.value;

        /* update paired select (mobile/desktop) */
        s2.querySelectorAll('[data-addon-variant-select][data-prod="' + key + '"]').forEach(function(other) {
          if (other !== e.target) other.value = newVid;
        });

        /* update price label */
        var priceEl = s2.querySelector('[data-price-display="' + key + '"]');
        if (priceEl && newPrice) priceEl.textContent = '$' + (newPrice / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        /* update checkbox so book button picks up the right variant */
        var chk = s2.querySelector('#pi-addon-' + key);
        if (chk) {
          chk.dataset.variantId = newVid;
          chk.dataset.price     = newPrice;
          chk.value             = newVid;
        }

        updateAddonTotal();
      });
    });

    /* ── Checkbox change → pulse + total ── */
    s2.querySelectorAll('.pi-addon-chk').forEach(function(chk) {
      chk.addEventListener('change', function() {
        var item = chk.closest('.addon-item');
        if (chk.checked && item) {
          item.classList.add('is-added');
          setTimeout(function() { item.classList.remove('is-added'); }, 700);
        }
        updateAddonTotal();
      });
    });
  }

  /* ── Add-ons total ── */
  function updateAddonTotal() {
    var totalEl = document.getElementById('pi-addons-total-' + sid);
    var priceEl = document.getElementById('pi-addons-price-'  + sid);
    if (!totalEl || !priceEl) return;

    var total = 0;
    s2.querySelectorAll('.pi-addon-chk:checked').forEach(function(chk) {
      total += parseInt(chk.dataset.price || '0', 10);
    });

    if (total > 0) {
      priceEl.textContent = '$' + (total / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      totalEl.removeAttribute('hidden');
    } else {
      totalEl.setAttribute('hidden', '');
    }
  }

  /* ── Init add-ons when step 2 becomes visible ── */
  nextBtn.addEventListener('click', function() {
    /* small timeout so the panel has transitioned in */
    setTimeout(initAddons, 50);
  });
});

})();

  } catch(e) { console.error(e); }
})();
})();
